/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull po-frontapp'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 5
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/competera/Platform%20PROD/implementation/po-frontapp)
 */

import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'production'

export const ApiKey: Record<Environment, string> = {
	production: '6d2809c6c555db4a9d3a3ea915b4bdf5',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
	plan: {
		version: '5',
		branch: 'main',
		source: 'po-frontapp',
		versionId: '5767eceb-c1bd-4ad1-a94f-fb7680b7daa8',
	},
	...{
		ingestionMetadata: {
			sourceName: 'browser-typescript-ampli',
			sourceVersion: '2.0.0',
		},
	},
}

export interface LoadOptionsBase {
	disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
	environment: Environment
	client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & {
	client: { apiKey: string; configuration?: BrowserOptions }
}
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
	client: { instance: BrowserClient }
}

export type LoadOptions =
	| LoadOptionsWithEnvironment
	| LoadOptionsWithApiKey
	| LoadOptionsWithClientInstance

export interface IdentifyProperties {
	clientName?: any
	initial_dclid?: string
	initial_fbclid?: string
	initial_gbraid?: string
	initial_gclid?: string
	initial_ko_click_id?: string
	initial_li_fat_id?: string
	initial_msclkid?: string
	initial_referrer?: string
	initial_referring_domain?: string
	projectId?: string
	referrer?: string
	referring_domain?: string
	uiLocale?: any
	uiScreenH?: any
	uiScreenW?: any
	uiTheme?: any
	userEmail?: any
	userFirstName?: any
	userLastName?: any
	userName?: any
	userRole?: any
}

export interface AiChatClickedSuggestionProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	suggestion?: string
}

export interface AlertsAnchoringHitShowNotificationProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsAssortmentHitShowNotificationProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsAssortmentHitShowNotificationsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsItemBadgeClickedProperties {
	alert_kind: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | pc, whatif, og, assortment, anchoring |
	 */
	alerts_of: 'pc' | 'whatif' | 'og' | 'assortment' | 'anchoring'
	is_alert_exact: boolean
}

export interface AlertsOgHitShowNotificationProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsOgHitShowNotificationsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsOpenClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | pc, whatif, og, assortment, anchoring |
	 */
	alerts_of: 'pc' | 'whatif' | 'og' | 'assortment' | 'anchoring'
}

export interface AlertsPcHitShowNotificationProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsPcHitShowNotificationsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsProductsHitShowNotificationProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsProductsHitShowNotificationsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	kind?: string
}

export interface AlertsSectionToggledProperties {
	alert_kind: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | pc, whatif, og, assortment, anchoring |
	 */
	alerts_of: 'pc' | 'whatif' | 'og' | 'assortment' | 'anchoring'
}

export interface AlertsViewSolutionClickedProperties {
	alert_kind: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | pc, whatif, og, assortment, anchoring |
	 */
	alerts_of: 'pc' | 'whatif' | 'og' | 'assortment' | 'anchoring'
}

export interface AnchorStrategyOpenClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	id?: string
	page?: any
}

export interface AnchoringManagementCreateAnchorStrategyProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface AnchoringAnchorStrategyAddFamilyFiltersProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	filters_value?: string[]
}

export interface AnchoringAnchorStrategyUpdateAggregationRuleProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	filter_value?: string
}

export interface ApprovalCreateReviewProperties {
	'Notify author'?: any
	'Reviewers count'?: any
}

export interface AutorunCreateScheduleProperties {
	'amount of notif users'?: any
	'amount of ogs'?: any
	'days of a week'?: any
	repeat?: any
	'start date'?: any
}

export interface AutorunDeleteScheduleProperties {
	'configuration name'?: any
}

export interface AutorunUpdateScheduleProperties {
	'configuration name'?: any
}

export interface BrowseOgListProperties {
	'Data freshness'?: any
	'OG amount'?: any
}

export interface BuilderDropProperties {
	template_type?: any
}

export interface BuilderSaveProperties {
	is_new?: any
}

export interface CommandExecuteProperties {
	command_category: string
}

export interface DashboardBiAdditionalMetricsChoiseForHistoricalGraphProperties {
	metric?: any
}

export interface DashboardBiApplyFilterHistoricalPriceAcceptanceProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'filter by'?: string
}

export interface DashboardBiApplyFilterMetricsByBrandProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterMetricsByOptimizationGroupProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterMetricsByPricingCampaignProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterOptimizationHistoryDonutProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterOptimizationHistoryTableProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterRepricedByPricingEngineProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterRevenueUnderManagementByEngineProperties {
	'filter by'?: any
}

export interface DashboardBiApplyFilterSalesFactorsImpactProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'filter by'?: string
}

export interface DashboardBiMainMetricChoiceForHistoricalGraphProperties {
	metric?: any
	value: string
}

export interface DashboardBiSwitchRevenuePeriodInMetricToCompareProperties {
	value: string
}

export interface ExportModalCreateExportProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	aggregation?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	exportDestination?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	fields?: string[]
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	fields_preset?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	format?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	name?: string
}

export interface ExportParamsChangeTypeProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	type?: string
}

export interface ExportParamsFieldsConfigurationBackProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
}

export interface ExportParamsFieldsConfigurationChangeFieldNameProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
	field?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	name?: string
}

export interface ExportParamsFieldsConfigurationChangeFieldRefProperties {
	field?: any
	value: string
}

export interface ExportParamsFieldsConfigurationOpenProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
}

export interface ExportParamsFieldsConfigurationToggleVisabilityProperties {
	enabled?: boolean
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
	field?: any
}

export interface ExportParamsSetParamsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	aggregation?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	export_kind?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	fields_preset?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	format?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	name?: string
}

export interface GlobalPcSetActionClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | delete, duplicate, rename, promote |
	 */
	global_pc_set_action: 'delete' | 'duplicate' | 'rename' | 'promote'
}

export interface GlobalPcSetComparisonActionClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | add_panel, remove_panel |
	 */
	global_pc_set_comparison_action: 'add_panel' | 'remove_panel'
}

export interface GlobalPcConfirmationModalRevokeOgProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	status: string
}

export interface GlobalAssortmentSaveChangesProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface JsdCreateTicketSubmitFormProperties {
	attachments?: any
}

export interface MassRepricingActionApplyProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionDiscardProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface MassRepricingActionExportPricesProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionPendingProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionRestartProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionRevokeProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionStartProperties {
	'Mass action by'?: any
}

export interface MassRepricingActionStopProperties {
	'Mass action by'?: any
}

export interface MassRepricingUpdateDataFromFileProperties {
	'Ignore empty fields'?: any
}

export interface OgViewProperties {
	mode?: any
}

export interface OptSummaryGlobItemsChangedWidgetClickRowProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	filters?: string[]
}

export interface OptSummaryGlobPromoWidgetClickRowProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	filters?: string[]
}

export interface OptSummaryGlobUseTableFiltersSwitchProperties {
	value: string
}

export interface OptSummaryItemsChangedWidgetClickRowProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	filters?: string[]
}

export interface OptSummaryPromoWidgetClickRowProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	filters?: string[]
}

export interface OptSummaryUseTableFiltersSwitchProperties {
	value: string
}

export interface PcReorderPrioritySaveProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	pcs_type?: string
}

export interface PcsTimelineCampaignNameClickProperties {
	destination?: any
}

export interface PcsTimelineFrequencyClickProperties {
	value: string
}

export interface PcsTimelineProductsCountClickProperties {
	destination?: any
}

export interface PreferencesUpdatePreferencesProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface PricingCampaignSettingsExampleClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	type?: string
}

export interface ProductsInterpretationProperties {
	Engine?: any
}

export interface ReportsCreateReportProperties {
	'Is global'?: any
}

export interface ReportsDeleteReportProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ReportsDownloadReportProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ReportsEditReportProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ReportsOpenReportProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ReportsOpenReportNewWindowProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ReportsUpdateReportProperties {
	'Is global'?: any
}

export interface RepricingApplyPricesProperties {
	'Export final prices file'?: any
	'OG name'?: any
	'Products amount'?: any
}

export interface RepricingCancelRepricingProperties {
	'OG name'?: any
	'Products amount'?: any
}

export interface RepricingCommitProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'OG name'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Type | number |
	 */
	'Products amount'?: number
}

export interface RepricingExportAppliedProicesProperties {
	'OG name'?: any
	'Products amount'?: any
}

export interface RepricingRestartProperties {
	'Is scheduled'?: any
	'OG name'?: any
	'Products amount'?: any
}

export interface RepricingStartProperties {
	'Is scheduled'?: any
	'OG name'?: any
	'Products amount'?: any
}

export interface RepricingStopProperties {
	'OG name'?: any
	'Products amount'?: any
}

export interface SavedFiltersClickOnFilterProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	from?: string
}

export interface ScenarioPanelEditClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioPanelPricingCampaignEditClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioPanelPricingCampaignRemoveClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioPanelPricingCampaignSelectProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioPanelRemoveClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioPanelSelectScenarioProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioDeleteProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioDuplicateProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenarioTabClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	tab?: string
}

export interface ScenariosAddPanelProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Type | number |
	 */
	panels?: number
}

export interface ScenariosCreateScenarioProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface ScenariosDuplicatePricingCampaignsProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface ScenariosPricingCampaignsDeleteProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	count?: any
}

export interface ScenariosPricingCampaignsReorderProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface ScenariosRunProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Type | number |
	 */
	automatic_count?: number
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Type | number |
	 */
	manual_count?: number
}

export interface ScenariosSelectTabProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	tab?: string
}

export interface ScenariosSidebarSelectScenarioProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface SettingsCopySettingsSelectSettingsProperties {
	'Settings to copy'?: any
}

export interface SettingsOgModalTabClickProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	tab?: string
}

export interface SettingsPricingCampaignsCreatePcClickProperties {
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface SettingsPricingCampaignsDeletePcProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain': string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location': string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path': string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title': string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL': string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Previous Page Location'?: string
	'[Amplitude] Previous Page Type'?: any
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	location: string
	page?: any
}

export interface SettingsPricingCampaignsFilterApplyProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	rules?: string[]
}

export interface SettingsPricingCampaignsReorderClickProperties {
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPcProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export interface SettingsPricingCampaignsTableSelectCopyOptionProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	value?: string
}

export interface SettingsPricingCampaignsTableSortByProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	value?: string[]
}

export interface SettingsPricingCampaignsViewClickProperties {
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface SettingsPromoCampaignsTableSortByProperties {
	value: string
}

export interface SkuSidebarTabClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	tab?: string
}

export interface TableAddQuickFilterProperties {
	preferenceKey?: any
}

export interface TableAssignToPricingCampaignProperties {
	'Assign to'?: any
}

export interface TableClearQuickFilterProperties {
	preferenceKey?: any
}

export interface TableImportFromFileProperties {
	'Ignore empty fields'?: any
}

export interface TableManualUpdateProperties {
	'Amount of fields for updating'?: any
}

export interface TableNewPriceEditingProperties {
	'Set new price'?: any
}

export interface TableRemoveQuickFilterProperties {
	preferenceKey?: any
}

export interface TableUpdateQuickFilterProperties {
	preferenceKey?: any
}

export interface VideoTutorialsCloseProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	tags?: string[]
}

export interface VideoTutorialsOpenProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	tags?: string[]
}

export interface VideoTutorialsWatchProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	language?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Item Type | string |
	 */
	tags?: string[]
}

export interface WhatIfCompareClickedProperties {
	whatif_compare_type: string
}

export interface WhatIfCreateScenarioModalOpenProperties {
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface WhatIfDuplicatePcsToScenarioModalOpenProperties {
	/**
	 * The location from where it was called
	 */
	location?: string
}

export interface WhatIfDuplicatePcsToScenarioModalSubmitProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Type | number |
	 */
	pcs?: number
}

export interface WhatIfRunsSetActionClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Enum Values | share, delete |
	 */
	runs_set_action: 'share' | 'delete'
}

export interface WhatIfSummaryChartTabClickedProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	tab?: string
}

export interface WhatIfSummaryRunProperties {
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Domain'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Location'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Path'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page Title'?: string
	/**
	 * | Rule | Value |
	 * |---|---|
	 * | Regex |  |
	 */
	'[Amplitude] Page URL'?: string
	'[Amplitude] Previous Page Location'?: any
	'[Amplitude] Previous Page Type'?: any
}

export class Identify implements BaseEvent {
	event_type = amplitude.Types.SpecialEventType.IDENTIFY

	constructor(public event_properties?: IdentifyProperties) {
		this.event_properties = event_properties
	}
}

export class AiChatClickedSuggestion implements BaseEvent {
	event_type = 'ai: chat: clicked suggestion'

	constructor(public event_properties?: AiChatClickedSuggestionProperties) {
		this.event_properties = event_properties
	}
}

export class AiChatClosed implements BaseEvent {
	event_type = 'ai: chat: closed'
}

export class AiChatOpened implements BaseEvent {
	event_type = 'ai: chat: opened'
}

export class AiChatResetConversation implements BaseEvent {
	event_type = 'ai: chat: reset conversation'
}

export class AiChatSentUserMessage implements BaseEvent {
	event_type = 'ai: chat: sent user message'
}

export class AlertsAnchoringClickOpenSidebar implements BaseEvent {
	event_type = 'alerts: anchoring: click open sidebar'
}

export class AlertsAnchoringHitShowNotification implements BaseEvent {
	event_type = 'alerts: anchoring: hit show notification'

	constructor(
		public event_properties?: AlertsAnchoringHitShowNotificationProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsAssortmentClickOpenSidebar implements BaseEvent {
	event_type = 'alerts: assortment: click open sidebar'
}

export class AlertsAssortmentHitShowNotification implements BaseEvent {
	event_type = 'alerts: assortment: hit show notification'

	constructor(
		public event_properties?: AlertsAssortmentHitShowNotificationProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsAssortmentHitShowNotifications implements BaseEvent {
	event_type = 'alerts: assortment: hit show notifications'

	constructor(
		public event_properties?: AlertsAssortmentHitShowNotificationsProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsAssortmentHitTheListOfNotifications implements BaseEvent {
	event_type = 'alerts: assortment: hit the list of notifications'
}

export class AlertsItemBadgeClicked implements BaseEvent {
	event_type = 'alerts: item: badge: clicked'

	constructor(public event_properties: AlertsItemBadgeClickedProperties) {
		this.event_properties = event_properties
	}
}

export class AlertsOgClickOpenSidebar implements BaseEvent {
	event_type = 'alerts: og: click open sidebar'
}

export class AlertsOgClickShowSolution implements BaseEvent {
	event_type = 'alerts: og: click show solution'
}

export class AlertsOgHitShowNotification implements BaseEvent {
	event_type = 'alerts: og: hit show notification'

	constructor(public event_properties?: AlertsOgHitShowNotificationProperties) {
		this.event_properties = event_properties
	}
}

export class AlertsOgHitShowNotifications implements BaseEvent {
	event_type = 'alerts: og: hit show notifications'

	constructor(
		public event_properties?: AlertsOgHitShowNotificationsProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsOgHitTheListOfNotifications implements BaseEvent {
	event_type = 'alerts: og: hit the list of notifications'
}

export class AlertsOpenClicked implements BaseEvent {
	event_type = 'alerts: open clicked'

	constructor(public event_properties: AlertsOpenClickedProperties) {
		this.event_properties = event_properties
	}
}

export class AlertsPcHitShowNotification implements BaseEvent {
	event_type = 'alerts: pc: hit show notification'

	constructor(public event_properties?: AlertsPcHitShowNotificationProperties) {
		this.event_properties = event_properties
	}
}

export class AlertsPcHitShowNotifications implements BaseEvent {
	event_type = 'alerts: pc: hit show notifications'

	constructor(
		public event_properties?: AlertsPcHitShowNotificationsProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsPcHitTheListOfNotifications implements BaseEvent {
	event_type = 'alerts: pc: hit the list of notifications'
}

export class AlertsProductsHitShowNotification implements BaseEvent {
	event_type = 'alerts: products: hit show notification'

	constructor(
		public event_properties?: AlertsProductsHitShowNotificationProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsProductsHitShowNotifications implements BaseEvent {
	event_type = 'alerts: products: hit show notifications'

	constructor(
		public event_properties?: AlertsProductsHitShowNotificationsProperties
	) {
		this.event_properties = event_properties
	}
}

export class AlertsProductsHitTheListOfNotifications implements BaseEvent {
	event_type = 'alerts: products: hit the list of notifications'
}

export class AlertsSectionToggled implements BaseEvent {
	event_type = 'alerts: section: toggled'

	constructor(public event_properties: AlertsSectionToggledProperties) {
		this.event_properties = event_properties
	}
}

export class AlertsViewSolutionClicked implements BaseEvent {
	event_type = 'alerts: view solution: clicked'

	constructor(public event_properties: AlertsViewSolutionClickedProperties) {
		this.event_properties = event_properties
	}
}

export class AnchorStrategyOpenClick implements BaseEvent {
	event_type = 'anchor strategy: open: click'

	constructor(public event_properties?: AnchorStrategyOpenClickProperties) {
		this.event_properties = event_properties
	}
}

export class AnchoringManagementCreateAnchorStrategy implements BaseEvent {
	event_type = 'anchoring-management: create anchor strategy'

	constructor(
		public event_properties?: AnchoringManagementCreateAnchorStrategyProperties
	) {
		this.event_properties = event_properties
	}
}

export class AnchoringAnchorApprovalClickApprove implements BaseEvent {
	event_type = 'anchoring: anchor approval: click approve'
}

export class AnchoringAnchorApprovalClickApproveAll implements BaseEvent {
	event_type = 'anchoring: anchor approval: click approve all'
}

export class AnchoringAnchorApprovalClickReject implements BaseEvent {
	event_type = 'anchoring: anchor approval: click reject'
}

export class AnchoringAnchorApprovalClickRejectAll implements BaseEvent {
	event_type = 'anchoring: anchor approval: click reject all'
}

export class AnchoringAnchorStrategyAddAggregation implements BaseEvent {
	event_type = 'anchoring: anchor strategy: add aggregation'
}

export class AnchoringAnchorStrategyAddFamily implements BaseEvent {
	event_type = 'anchoring: anchor strategy: add family'
}

export class AnchoringAnchorStrategyAddFamilyFilters implements BaseEvent {
	event_type = 'anchoring: anchor strategy: add family filters'

	constructor(
		public event_properties?: AnchoringAnchorStrategyAddFamilyFiltersProperties
	) {
		this.event_properties = event_properties
	}
}

export class AnchoringAnchorStrategyAddPriceColumn implements BaseEvent {
	event_type = 'anchoring: anchor strategy: add price column'
}

export class AnchoringAnchorStrategyOpenFamilies implements BaseEvent {
	event_type = 'anchoring: anchor strategy: open families'
}

export class AnchoringAnchorStrategyOpenGeneral implements BaseEvent {
	event_type = 'anchoring: anchor strategy: open general'
}

export class AnchoringAnchorStrategyOpenPriceDistance implements BaseEvent {
	event_type = 'anchoring: anchor strategy: open price distance'
}

export class AnchoringAnchorStrategyUpdateAggregationRule implements BaseEvent {
	event_type = 'anchoring: anchor strategy: update aggregation rule'

	constructor(
		public event_properties?: AnchoringAnchorStrategyUpdateAggregationRuleProperties
	) {
		this.event_properties = event_properties
	}
}

export class AnchoringApplyFilters implements BaseEvent {
	event_type = 'anchoring: apply filters'
}

export class AnchoringDeleteSelectedRowsClick implements BaseEvent {
	event_type = 'anchoring: delete selected rows: click'
}

export class AnchoringExportTableClick implements BaseEvent {
	event_type = 'anchoring: export table: click'
}

export class AnchoringExportDownload implements BaseEvent {
	event_type = 'anchoring: export: download'
}

export class AnchoringImportFromFileClick implements BaseEvent {
	event_type = 'anchoring: import from file: click'
}

export class AnchoringImportFromFileDownloadTemplate implements BaseEvent {
	event_type = 'anchoring: import from file: download template'
}

export class AnchoringImportFromFileUpload implements BaseEvent {
	event_type = 'anchoring: import from file: upload'
}

export class AnchoringRevertManualChangesClick implements BaseEvent {
	event_type = 'anchoring: revert manual changes: click'
}

export class AnchoringSaveManualChangesClick implements BaseEvent {
	event_type = 'anchoring: save manual changes: click'
}

export class AnchoringTableCountClick implements BaseEvent {
	event_type = 'anchoring: table: count: click'
}

export class AnchoringTableCreateAnchor implements BaseEvent {
	event_type = 'anchoring: table: create anchor'
}

export class AnchoringTableCreateAnchorSave implements BaseEvent {
	event_type = 'anchoring: table: create anchor: save'
}

export class AnchoringTableSkuClick implements BaseEvent {
	event_type = 'anchoring: table: sku: click'
}

export class AnchoringViewAnchorStrategy implements BaseEvent {
	event_type = 'anchoring: view anchor strategy'
}

export class ApprovalCreateReview implements BaseEvent {
	event_type = 'approval: create review'

	constructor(public event_properties?: ApprovalCreateReviewProperties) {
		this.event_properties = event_properties
	}
}

export class ApprovalOpenReviewManagerModal implements BaseEvent {
	event_type = 'approval: open review manager modal'
}

export class AutorunCreateSchedule implements BaseEvent {
	event_type = 'autorun: Create schedule'

	constructor(public event_properties?: AutorunCreateScheduleProperties) {
		this.event_properties = event_properties
	}
}

export class AutorunDeleteSchedule implements BaseEvent {
	event_type = 'autorun: Delete schedule'

	constructor(public event_properties?: AutorunDeleteScheduleProperties) {
		this.event_properties = event_properties
	}
}

export class AutorunFilterScheduledOGs implements BaseEvent {
	event_type = 'autorun: Filter scheduled OGs'
}

export class AutorunUpdateSchedule implements BaseEvent {
	event_type = 'autorun: Update schedule'

	constructor(public event_properties?: AutorunUpdateScheduleProperties) {
		this.event_properties = event_properties
	}
}

export class BrowseAiDashboard implements BaseEvent {
	event_type = 'browse: ai dashboard'
}

export class BrowseAnchorApproval implements BaseEvent {
	event_type = 'browse: anchor approval'
}

export class BrowseAnchorStrategy implements BaseEvent {
	event_type = 'browse: anchor strategy'
}

export class BrowseAnchoringManagementAssortment implements BaseEvent {
	event_type = 'browse: anchoring management assortment'
}

export class BrowseDashboard implements BaseEvent {
	event_type = 'browse: dashboard'
}

export class BrowseLogout implements BaseEvent {
	event_type = 'browse: logout'
}

export class BrowseOgList implements BaseEvent {
	event_type = 'browse: og list'

	constructor(public event_properties?: BrowseOgListProperties) {
		this.event_properties = event_properties
	}
}

export class BrowsePricingCampaigns implements BaseEvent {
	event_type = 'browse: pricing campaigns'
}

export class BrowseProductAssortment implements BaseEvent {
	event_type = 'browse: product assortment'
}

export class BrowseSavedReports implements BaseEvent {
	event_type = 'browse: saved reports'
}

export class BuilderDrop implements BaseEvent {
	event_type = 'builder: drop'

	constructor(public event_properties?: BuilderDropProperties) {
		this.event_properties = event_properties
	}
}

export class BuilderOpen implements BaseEvent {
	event_type = 'builder: open'
}

export class BuilderReset implements BaseEvent {
	event_type = 'builder: reset'
}

export class BuilderSave implements BaseEvent {
	event_type = 'builder: save'

	constructor(public event_properties?: BuilderSaveProperties) {
		this.event_properties = event_properties
	}
}

export class ColumnsOrderChanged implements BaseEvent {
	event_type = 'columns: order: changed'
}

export class CommandExecute implements BaseEvent {
	event_type = 'command: execute'

	constructor(public event_properties: CommandExecuteProperties) {
		this.event_properties = event_properties
	}
}

export class CreateOgCloseModal implements BaseEvent {
	event_type = 'create og: close modal'
}

export class CreateOgGoNextStep implements BaseEvent {
	event_type = 'create og: go next step'
}

export class CreateOgGoPrevStep implements BaseEvent {
	event_type = 'create og: go prev step'
}

export class CreateOgSubmitForm implements BaseEvent {
	event_type = 'create og: submit form'
}

export class DashboardBiAdditionalMetricsChoiseForHistoricalGraph implements BaseEvent {
	event_type = 'dashboard: bi: additional metrics choise for historical graph'

	constructor(
		public event_properties?: DashboardBiAdditionalMetricsChoiseForHistoricalGraphProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterHistoricalPriceAcceptance implements BaseEvent {
	event_type = 'dashboard: bi: apply filter HistoricalPriceAcceptance'

	constructor(
		public event_properties?: DashboardBiApplyFilterHistoricalPriceAcceptanceProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterMetricsByBrand implements BaseEvent {
	event_type = 'dashboard: bi: apply filter MetricsByBrand'

	constructor(
		public event_properties?: DashboardBiApplyFilterMetricsByBrandProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterMetricsByOptimizationGroup implements BaseEvent {
	event_type = 'dashboard: bi: apply filter MetricsByOptimizationGroup'

	constructor(
		public event_properties?: DashboardBiApplyFilterMetricsByOptimizationGroupProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterMetricsByPricingCampaign implements BaseEvent {
	event_type = 'dashboard: bi: apply filter MetricsByPricingCampaign'

	constructor(
		public event_properties?: DashboardBiApplyFilterMetricsByPricingCampaignProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterOptimizationHistoryDonut implements BaseEvent {
	event_type = 'dashboard: bi: apply filter OptimizationHistoryDonut'

	constructor(
		public event_properties?: DashboardBiApplyFilterOptimizationHistoryDonutProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterOptimizationHistoryTable implements BaseEvent {
	event_type = 'dashboard: bi: apply filter OptimizationHistoryTable'

	constructor(
		public event_properties?: DashboardBiApplyFilterOptimizationHistoryTableProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterRepricedByPricingEngine implements BaseEvent {
	event_type = 'dashboard: bi: apply filter RepricedByPricingEngine'

	constructor(
		public event_properties?: DashboardBiApplyFilterRepricedByPricingEngineProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterRevenueUnderManagementByEngine implements BaseEvent {
	event_type = 'dashboard: bi: apply filter RevenueUnderManagementByEngine'

	constructor(
		public event_properties?: DashboardBiApplyFilterRevenueUnderManagementByEngineProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterRevenueUnderManagementByPriceChange implements BaseEvent {
	event_type = 'dashboard: bi: apply filter RevenueUnderManagementByPriceChange'
}

export class DashboardBiApplyFilterSalesFactorsImpact implements BaseEvent {
	event_type = 'dashboard: bi: apply filter SalesFactorsImpact'

	constructor(
		public event_properties?: DashboardBiApplyFilterSalesFactorsImpactProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiApplyFilterSalesFactorsImpactByCategories implements BaseEvent {
	event_type = 'dashboard: bi: apply filter SalesFactorsImpactByCategories'
}

export class DashboardBiApplyFilterSalesFactorsImpactDynamic implements BaseEvent {
	event_type = 'dashboard: bi: apply filter SalesFactorsImpactDynamic'
}

export class DashboardBiMainMetricChoiceForHistoricalGraph implements BaseEvent {
	event_type = 'dashboard: bi: main metric choice for historical graph'

	constructor(
		public event_properties: DashboardBiMainMetricChoiceForHistoricalGraphProperties
	) {
		this.event_properties = event_properties
	}
}

export class DashboardBiProceedToProductWarnings implements BaseEvent {
	event_type = 'dashboard: bi: proceed to product warnings'
}

export class DashboardBiProceedToUnassignedList implements BaseEvent {
	event_type = 'dashboard: bi: proceed to unassigned list'
}

export class DashboardBiSwitchRevenuePeriodInMetricToCompare implements BaseEvent {
	event_type = 'dashboard: bi: switch revenue period in metric to compare'

	constructor(
		public event_properties: DashboardBiSwitchRevenuePeriodInMetricToCompareProperties
	) {
		this.event_properties = event_properties
	}
}

export class ErrorErrorDisplayed implements BaseEvent {
	event_type = 'error: error displayed'
}

export class ExportModalCreateExport implements BaseEvent {
	event_type = 'export: modal: create export'

	constructor(public event_properties?: ExportModalCreateExportProperties) {
		this.event_properties = event_properties
	}
}

export class ExportParamsChangeType implements BaseEvent {
	event_type = 'export: params: change type'

	constructor(public event_properties?: ExportParamsChangeTypeProperties) {
		this.event_properties = event_properties
	}
}

export class ExportParamsFieldsConfigurationBack implements BaseEvent {
	event_type = 'export: params: fields configuration: back'

	constructor(
		public event_properties?: ExportParamsFieldsConfigurationBackProperties
	) {
		this.event_properties = event_properties
	}
}

export class ExportParamsFieldsConfigurationChangeFieldName implements BaseEvent {
	event_type = 'export: params: fields configuration: change field name'

	constructor(
		public event_properties?: ExportParamsFieldsConfigurationChangeFieldNameProperties
	) {
		this.event_properties = event_properties
	}
}

export class ExportParamsFieldsConfigurationChangeFieldRef implements BaseEvent {
	event_type = 'export: params: fields configuration: change field ref'

	constructor(
		public event_properties: ExportParamsFieldsConfigurationChangeFieldRefProperties
	) {
		this.event_properties = event_properties
	}
}

export class ExportParamsFieldsConfigurationOpen implements BaseEvent {
	event_type = 'export: params: fields configuration: open'

	constructor(
		public event_properties?: ExportParamsFieldsConfigurationOpenProperties
	) {
		this.event_properties = event_properties
	}
}

export class ExportParamsFieldsConfigurationToggleVisability implements BaseEvent {
	event_type = 'export: params: fields configuration: toggle visability'

	constructor(
		public event_properties?: ExportParamsFieldsConfigurationToggleVisabilityProperties
	) {
		this.event_properties = event_properties
	}
}

export class ExportParamsSetParams implements BaseEvent {
	event_type = 'export: params: set params'

	constructor(public event_properties?: ExportParamsSetParamsProperties) {
		this.event_properties = event_properties
	}
}

export class ExportsDeleteExport implements BaseEvent {
	event_type = 'exports: delete export'
}

export class GlobalAssortmentApplyFilters implements BaseEvent {
	event_type = 'global assortment: apply filters'
}

export class GlobalAssortmentDownloadAssortmentReport implements BaseEvent {
	event_type = 'global assortment: download assortment report'
}

export class GlobalPcSetActionClicked implements BaseEvent {
	event_type = 'global pc set: action clicked'

	constructor(public event_properties: GlobalPcSetActionClickedProperties) {
		this.event_properties = event_properties
	}
}

export class GlobalPcSetComparisonActionClicked implements BaseEvent {
	event_type = 'global pc set: comparison: action clicked'

	constructor(
		public event_properties: GlobalPcSetComparisonActionClickedProperties
	) {
		this.event_properties = event_properties
	}
}

export class GlobalPcSetCreateClicked implements BaseEvent {
	event_type = 'global pc set: create clicked'
}

export class GlobalPcConfirmationModalConfirm implements BaseEvent {
	event_type = 'global pc: confirmation modal: confirm'
}

export class GlobalPcConfirmationModalNavigateToOg implements BaseEvent {
	event_type = 'global pc: confirmation modal: navigate to OG'
}

export class GlobalPcConfirmationModalRevokeOg implements BaseEvent {
	event_type = 'global pc: confirmation modal: revoke OG'

	constructor(
		public event_properties: GlobalPcConfirmationModalRevokeOgProperties
	) {
		this.event_properties = event_properties
	}
}

export class GlobalProductsAssignToAnchors implements BaseEvent {
	event_type = 'global products: assign to anchors'
}

export class GlobalAssortmentSaveChanges implements BaseEvent {
	event_type = 'global-assortment: save changes'

	constructor(public event_properties?: GlobalAssortmentSaveChangesProperties) {
		this.event_properties = event_properties
	}
}

export class JsdCreateTicketOpenIntercom implements BaseEvent {
	event_type = 'jsd: create ticket: open intercom'
}

export class JsdCreateTicketOpenModal implements BaseEvent {
	event_type = 'jsd: create ticket: open modal'
}

export class JsdCreateTicketSubmitForm implements BaseEvent {
	event_type = 'jsd: create ticket: submit form'

	constructor(public event_properties?: JsdCreateTicketSubmitFormProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionApply implements BaseEvent {
	event_type = 'mass repricing: action: apply'

	constructor(public event_properties?: MassRepricingActionApplyProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionDiscard implements BaseEvent {
	event_type = 'mass repricing: action: discard'

	constructor(public event_properties?: MassRepricingActionDiscardProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionExportPrices implements BaseEvent {
	event_type = 'mass repricing: action: export prices'

	constructor(
		public event_properties?: MassRepricingActionExportPricesProperties
	) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionPending implements BaseEvent {
	event_type = 'mass repricing: action: pending'

	constructor(public event_properties?: MassRepricingActionPendingProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionRestart implements BaseEvent {
	event_type = 'mass repricing: action: restart'

	constructor(public event_properties?: MassRepricingActionRestartProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionRevert implements BaseEvent {
	event_type = 'mass repricing: action: revert'
}

export class MassRepricingActionRevoke implements BaseEvent {
	event_type = 'mass repricing: action: revoke'

	constructor(public event_properties?: MassRepricingActionRevokeProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionStart implements BaseEvent {
	event_type = 'mass repricing: action: start'

	constructor(public event_properties?: MassRepricingActionStartProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingActionStop implements BaseEvent {
	event_type = 'mass repricing: action: stop'

	constructor(public event_properties?: MassRepricingActionStopProperties) {
		this.event_properties = event_properties
	}
}

export class MassRepricingFilterAll implements BaseEvent {
	event_type = 'mass repricing: filter: all'
}

export class MassRepricingFilterFailed implements BaseEvent {
	event_type = 'mass repricing: filter: failed'
}

export class MassRepricingFilterFinished implements BaseEvent {
	event_type = 'mass repricing: filter: finished'
}

export class MassRepricingFilterLocked implements BaseEvent {
	event_type = 'mass repricing: filter: locked'
}

export class MassRepricingFilterNew implements BaseEvent {
	event_type = 'mass repricing: filter: new'
}

export class MassRepricingFilterPending implements BaseEvent {
	event_type = 'mass repricing: filter: pending'
}

export class MassRepricingFilterStarted implements BaseEvent {
	event_type = 'mass repricing: filter: started'
}

export class MassRepricingSearch implements BaseEvent {
	event_type = 'mass repricing: search'
}

export class MassRepricingUpdateDataFromFile implements BaseEvent {
	event_type = 'mass repricing: update data from file'

	constructor(
		public event_properties?: MassRepricingUpdateDataFromFileProperties
	) {
		this.event_properties = event_properties
	}
}

export class NavigationPromptCancel implements BaseEvent {
	event_type = 'navigation-prompt: cancel'
}

export class NavigationPromptConfirm implements BaseEvent {
	event_type = 'navigation-prompt: confirm'
}

export class NavigationPromptShow implements BaseEvent {
	event_type = 'navigation-prompt: show'
}

export class OgAssortmentApplyFilters implements BaseEvent {
	event_type = 'og assortment: apply filters'
}

export class OgListAlertsByOgOpen implements BaseEvent {
	event_type = 'og list: alerts by og: open'
}

export class OgListCreateOgClick implements BaseEvent {
	event_type = 'og list: create og: click'
}

export class OgListFiltersApply implements BaseEvent {
	event_type = 'og list: filters apply'
}

export class OgListImportFromFileClick implements BaseEvent {
	event_type = 'og list: import from file: click'
}

export class OgSettingsDeleteOg implements BaseEvent {
	event_type = 'og settings: delete og'
}

export class OgSettingsDescriptionModalOpen implements BaseEvent {
	event_type = 'og settings: description modal: open'
}

export class OgSettingsDescriptionModalSubmitForm implements BaseEvent {
	event_type = 'og settings: description modal: submit form'
}

export class OgSettingsResetForm implements BaseEvent {
	event_type = 'og settings: reset form'
}

export class OgSettingsSaveScenarioAsTemplate implements BaseEvent {
	event_type = 'og settings: save scenario as template'
}

export class OgProductListNewAnchorsBadgeClick implements BaseEvent {
	event_type = 'og: product list: new anchors badge: click'
}

export class OgView implements BaseEvent {
	event_type = 'og: view'

	constructor(public event_properties?: OgViewProperties) {
		this.event_properties = event_properties
	}
}

export class OptSummaryGlobItemsChangedWidgetClickRow implements BaseEvent {
	event_type = 'opt summary glob: items changed widget: click row'

	constructor(
		public event_properties?: OptSummaryGlobItemsChangedWidgetClickRowProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryGlobOpenOptimizationTab implements BaseEvent {
	event_type = 'opt summary glob: open optimization tab'
}

export class OptSummaryGlobOpenStatisticsTab implements BaseEvent {
	event_type = 'opt summary glob: open statistics tab'
}

export class OptSummaryGlobPromoWidgetClickRow implements BaseEvent {
	event_type = 'opt summary glob: promo widget: click row'

	constructor(
		public event_properties?: OptSummaryGlobPromoWidgetClickRowProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryGlobUseTableFiltersSwitch implements BaseEvent {
	event_type = 'opt summary glob: use table filters switch'

	constructor(
		public event_properties: OptSummaryGlobUseTableFiltersSwitchProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryItemsChangedWidgetClickRow implements BaseEvent {
	event_type = 'opt summary: items changed widget: click row'

	constructor(
		public event_properties?: OptSummaryItemsChangedWidgetClickRowProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryOpenOptimizationTab implements BaseEvent {
	event_type = 'opt summary: open optimization tab'
}

export class OptSummaryOpenProgressTab implements BaseEvent {
	event_type = 'opt summary: open progress tab'
}

export class OptSummaryOpenStatisticsTab implements BaseEvent {
	event_type = 'opt summary: open statistics tab'
}

export class OptSummaryPromoWidgetClickRow implements BaseEvent {
	event_type = 'opt summary: promo widget: click row'

	constructor(
		public event_properties?: OptSummaryPromoWidgetClickRowProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryUseTableFiltersSwitch implements BaseEvent {
	event_type = 'opt summary: use table filters switch'

	constructor(
		public event_properties: OptSummaryUseTableFiltersSwitchProperties
	) {
		this.event_properties = event_properties
	}
}

export class OptSummaryView implements BaseEvent {
	event_type = 'opt summary: view'
}

export class PcReorderPrioritySave implements BaseEvent {
	event_type = 'pc reorder: priority save'

	constructor(public event_properties?: PcReorderPrioritySaveProperties) {
		this.event_properties = event_properties
	}
}

export class PcApplyTemplateClicked implements BaseEvent {
	event_type = 'pc: apply template clicked'
}

export class PcCopyClicked implements BaseEvent {
	event_type = 'pc: copy clicked'
}

export class PcCopySettingsClicked implements BaseEvent {
	event_type = 'pc: copy settings clicked'
}

export class PcDeleteClicked implements BaseEvent {
	event_type = 'pc: delete clicked'
}

export class PcDuplicateClicked implements BaseEvent {
	event_type = 'pc: duplicate clicked'
}

export class PcDuplicateToClicked implements BaseEvent {
	event_type = 'pc: duplicate to clicked'
}

export class PcReassignClicked implements BaseEvent {
	event_type = 'pc: reassign clicked'
}

export class PcSaveAsTemplateClicked implements BaseEvent {
	event_type = 'pc: save as template clicked'
}

export class PcSaveSettingAsTemplateClicked implements BaseEvent {
	event_type = 'pc: save setting as template clicked'
}

export class PcSettingChanged implements BaseEvent {
	event_type = 'pc: setting changed'
}

export class PcUseSettingsTemplateClicked implements BaseEvent {
	event_type = 'pc: use settings template clicked'
}

export class PcsTimelineCampaignNameClick implements BaseEvent {
	event_type = 'pcs timeline: campaign name: click'

	constructor(
		public event_properties?: PcsTimelineCampaignNameClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class PcsTimelineFrequencyClick implements BaseEvent {
	event_type = 'pcs timeline: frequency: click'

	constructor(public event_properties: PcsTimelineFrequencyClickProperties) {
		this.event_properties = event_properties
	}
}

export class PcsTimelineProductsCountClick implements BaseEvent {
	event_type = 'pcs timeline: products count: click'

	constructor(
		public event_properties?: PcsTimelineProductsCountClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class PcsTimelineView implements BaseEvent {
	event_type = 'pcs timeline: view'
}

export class PcsOrderChnaged implements BaseEvent {
	event_type = 'pcs: order: chnaged'
}

export class PcsPricingCampaignsAlertsByPcOpen implements BaseEvent {
	event_type = 'pcs: pricing campaigns: alerts by pc: open'
}

export class PreferencesUpdatePreferences implements BaseEvent {
	event_type = 'preferences: update preferences'

	constructor(
		public event_properties?: PreferencesUpdatePreferencesProperties
	) {
		this.event_properties = event_properties
	}
}

export class PricingCampaignSettingsExampleClick implements BaseEvent {
	event_type = 'pricing-campaign: settings example: click'

	constructor(
		public event_properties?: PricingCampaignSettingsExampleClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class PricingSettingsAnchoringAddAnchorRule implements BaseEvent {
	event_type = 'pricing-settings: anchoring: add anchor rule'
}

export class PricingSettingsAnchoringRemoveAnchorRule implements BaseEvent {
	event_type = 'pricing-settings: anchoring: remove anchor rule'
}

export class ProductsInterpretation implements BaseEvent {
	event_type = 'products: interpretation'

	constructor(public event_properties?: ProductsInterpretationProperties) {
		this.event_properties = event_properties
	}
}

export class PromoCreate implements BaseEvent {
	event_type = 'promo: Create'
}

export class PromoDelete implements BaseEvent {
	event_type = 'promo: Delete'
}

export class PromoDownloadErrors implements BaseEvent {
	event_type = 'promo: Download errors'
}

export class PromoDownloadTemplate implements BaseEvent {
	event_type = 'promo: Download template'
}

export class PromoFilterByStatus implements BaseEvent {
	event_type = 'promo: filter by status'
}

export class PromoImportFile implements BaseEvent {
	event_type = 'promo: import File'
}

export class PromoOpenPromoListPage implements BaseEvent {
	event_type = 'promo: open Promo list Page'
}

export class PromoSearch implements BaseEvent {
	event_type = 'promo: search'
}

export class PromoUpdate implements BaseEvent {
	event_type = 'promo: Update'
}

export class ReportsCreateReport implements BaseEvent {
	event_type = 'reports: create report'

	constructor(public event_properties?: ReportsCreateReportProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsDeleteReport implements BaseEvent {
	event_type = 'reports: delete report'

	constructor(public event_properties?: ReportsDeleteReportProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsDownloadReport implements BaseEvent {
	event_type = 'reports: download report'

	constructor(public event_properties?: ReportsDownloadReportProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsEditReport implements BaseEvent {
	event_type = 'reports: edit report'

	constructor(public event_properties?: ReportsEditReportProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsOpenReport implements BaseEvent {
	event_type = 'reports: open report'

	constructor(public event_properties?: ReportsOpenReportProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsOpenReportNewWindow implements BaseEvent {
	event_type = 'reports: open report new window'

	constructor(public event_properties?: ReportsOpenReportNewWindowProperties) {
		this.event_properties = event_properties
	}
}

export class ReportsUpdateReport implements BaseEvent {
	event_type = 'reports: update report'

	constructor(public event_properties?: ReportsUpdateReportProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingApplyPrices implements BaseEvent {
	event_type = 'repricing: apply prices'

	constructor(public event_properties?: RepricingApplyPricesProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingCancelRepricing implements BaseEvent {
	event_type = 'repricing: cancel repricing'

	constructor(public event_properties?: RepricingCancelRepricingProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingCommit implements BaseEvent {
	event_type = 'repricing: commit'

	constructor(public event_properties?: RepricingCommitProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingExportAppliedProices implements BaseEvent {
	event_type = 'repricing: export applied proices'

	constructor(
		public event_properties?: RepricingExportAppliedProicesProperties
	) {
		this.event_properties = event_properties
	}
}

export class RepricingRestart implements BaseEvent {
	event_type = 'repricing: restart'

	constructor(public event_properties?: RepricingRestartProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingStart implements BaseEvent {
	event_type = 'repricing: start'

	constructor(public event_properties?: RepricingStartProperties) {
		this.event_properties = event_properties
	}
}

export class RepricingStop implements BaseEvent {
	event_type = 'repricing: stop'

	constructor(public event_properties?: RepricingStopProperties) {
		this.event_properties = event_properties
	}
}

export class SavedFiltersClickOnFilter implements BaseEvent {
	event_type = 'saved-filters: click on filter'

	constructor(public event_properties?: SavedFiltersClickOnFilterProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelEditClick implements BaseEvent {
	event_type = 'scenario panel: edit: click'

	constructor(public event_properties?: ScenarioPanelEditClickProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelPricingCampaignEditClick implements BaseEvent {
	event_type = 'scenario panel: pricing campaign: edit: click'

	constructor(
		public event_properties?: ScenarioPanelPricingCampaignEditClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelPricingCampaignRemoveClick implements BaseEvent {
	event_type = 'scenario panel: pricing campaign: remove: click'

	constructor(
		public event_properties?: ScenarioPanelPricingCampaignRemoveClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelPricingCampaignSelect implements BaseEvent {
	event_type = 'scenario panel: pricing campaign: select'

	constructor(
		public event_properties?: ScenarioPanelPricingCampaignSelectProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelRemoveClick implements BaseEvent {
	event_type = 'scenario panel: remove: click'

	constructor(public event_properties?: ScenarioPanelRemoveClickProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioPanelSelectScenario implements BaseEvent {
	event_type = 'scenario panel: select scenario'

	constructor(public event_properties?: ScenarioPanelSelectScenarioProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioChangesSaved implements BaseEvent {
	event_type = 'scenario: changes saved'
}

export class ScenarioDelete implements BaseEvent {
	event_type = 'scenario: delete'

	constructor(public event_properties?: ScenarioDeleteProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioDuplicate implements BaseEvent {
	event_type = 'scenario: duplicate'

	constructor(public event_properties?: ScenarioDuplicateProperties) {
		this.event_properties = event_properties
	}
}

export class ScenarioPromoteClicked implements BaseEvent {
	event_type = 'scenario: promote clicked'
}

export class ScenarioTabClick implements BaseEvent {
	event_type = 'scenario: tab: click'

	constructor(public event_properties?: ScenarioTabClickProperties) {
		this.event_properties = event_properties
	}
}

export class ScenariosAddPanel implements BaseEvent {
	event_type = 'scenarios: add panel'

	constructor(public event_properties?: ScenariosAddPanelProperties) {
		this.event_properties = event_properties
	}
}

export class ScenariosCreateScenario implements BaseEvent {
	event_type = 'scenarios: create scenario'

	constructor(public event_properties?: ScenariosCreateScenarioProperties) {
		this.event_properties = event_properties
	}
}

export class ScenariosDuplicatePricingCampaigns implements BaseEvent {
	event_type = 'scenarios: duplicate pricing campaigns'

	constructor(
		public event_properties?: ScenariosDuplicatePricingCampaignsProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenariosPricingCampaignsDelete implements BaseEvent {
	event_type = 'scenarios: pricing campaigns: delete'

	constructor(
		public event_properties?: ScenariosPricingCampaignsDeleteProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenariosPricingCampaignsReorder implements BaseEvent {
	event_type = 'scenarios: pricing campaigns: reorder'

	constructor(
		public event_properties?: ScenariosPricingCampaignsReorderProperties
	) {
		this.event_properties = event_properties
	}
}

export class ScenariosRun implements BaseEvent {
	event_type = 'scenarios: run'

	constructor(public event_properties?: ScenariosRunProperties) {
		this.event_properties = event_properties
	}
}

export class ScenariosSelectTab implements BaseEvent {
	event_type = 'scenarios: select tab'

	constructor(public event_properties?: ScenariosSelectTabProperties) {
		this.event_properties = event_properties
	}
}

export class ScenariosSidebarSelectScenario implements BaseEvent {
	event_type = 'scenarios: sidebar: select scenario'

	constructor(
		public event_properties?: ScenariosSidebarSelectScenarioProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsCopySettingsConfirm implements BaseEvent {
	event_type = 'settings: copy settings: confirm'
}

export class SettingsCopySettingsFinish implements BaseEvent {
	event_type = 'settings: copy settings: finish'
}

export class SettingsCopySettingsSelectSettings implements BaseEvent {
	event_type = 'settings: copy settings: select settings'

	constructor(
		public event_properties?: SettingsCopySettingsSelectSettingsProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsCopySettingsStart implements BaseEvent {
	event_type = 'settings: copy settings: start'
}

export class SettingsDropdownApplyTemplate implements BaseEvent {
	event_type = 'settings: dropdown: apply template'
}

export class SettingsDropdownSaveSettingAsTemplate implements BaseEvent {
	event_type = 'settings: dropdown: save setting as template'
}

export class SettingsOgModalTabClick implements BaseEvent {
	event_type = 'settings: og modal: tab: click'

	constructor(public event_properties?: SettingsOgModalTabClickProperties) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsAddAMinimalPriceChange implements BaseEvent {
	event_type = 'settings: pricing campaigns: add a minimal price change'
}

export class SettingsPricingCampaignsAddRoundingRule implements BaseEvent {
	event_type = 'settings: pricing campaigns: add rounding rule'
}

export class SettingsPricingCampaignsBulkDeletePCs implements BaseEvent {
	event_type = 'settings: pricing campaigns: bulk delete PCs'
}

export class SettingsPricingCampaignsCreatePcClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: create pc: click'

	constructor(
		public event_properties?: SettingsPricingCampaignsCreatePcClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsDeleteAMinimalPriceChange implements BaseEvent {
	event_type = 'settings: pricing campaigns: delete a minimal price change'
}

export class SettingsPricingCampaignsDeletePc implements BaseEvent {
	event_type = 'settings: pricing campaigns: delete PC'

	constructor(
		public event_properties: SettingsPricingCampaignsDeletePcProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsDeleteRoundingRule implements BaseEvent {
	event_type = 'settings: pricing campaigns: delete rounding rule'
}

export class SettingsPricingCampaignsDemandStrategyChangeClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: demand strategy: change click'
}

export class SettingsPricingCampaignsDropdownApplyTemplate implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: apply template'
}

export class SettingsPricingCampaignsDropdownCopyPc implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: copy PC'
}

export class SettingsPricingCampaignsDropdownDublicatePc implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: dublicate PC'
}

export class SettingsPricingCampaignsDropdownReassignToAnotherOg implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: reassign to another OG'
}

export class SettingsPricingCampaignsDropdownSavePsAsTemplate implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: save ps as template'
}

export class SettingsPricingCampaignsDropdownSaveSettingAsTemplate implements BaseEvent {
	event_type = 'settings: pricing campaigns: dropdown: save setting as template'
}

export class SettingsPricingCampaignsEditRoundingRule implements BaseEvent {
	event_type = 'settings: pricing campaigns: edit rounding rule'
}

export class SettingsPricingCampaignsFilterApply implements BaseEvent {
	event_type = 'settings: pricing campaigns: filter apply'

	constructor(
		public event_properties?: SettingsPricingCampaignsFilterApplyProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsMarkdownPeriodAddPeriod implements BaseEvent {
	event_type = 'settings: pricing campaigns: markdown period: add period'
}

export class SettingsPricingCampaignsMarkdownPeriodDeletePeriod implements BaseEvent {
	event_type = 'settings: pricing campaigns: markdown period: delete period'
}

export class SettingsPricingCampaignsMarkdownChangeClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: markdown: change click'
}

export class SettingsPricingCampaignsProductsCountClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: products count click'
}

export class SettingsPricingCampaignsReorderClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: reorder: click'

	constructor(
		public event_properties?: SettingsPricingCampaignsReorderClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingAnchoringToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: anchoring to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingMinimalStepsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: minimal_steps to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingPriceLimitsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: price_limits to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingPricingTacticsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: pricing_tactics to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingProductAssignmentsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: product_assignments to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingRoundingToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: rounding to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsActivityToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.activity to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsAnchoringToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.anchoring to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsMinimalStepsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.minimal_steps to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.price_limits to PC'

	constructor(
		public event_properties?: SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPcProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPricingTacticsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.pricing_tactics to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsProductAssignmentsToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.product_assignments to PC'
}

export class SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsRoundingToPc implements BaseEvent {
	event_type =
		'settings: pricing campaigns: setting: dropdown: copy PC setting: settings.rounding to PC'
}

export class SettingsPricingCampaignsStrategyChangePeriod implements BaseEvent {
	event_type = 'settings: pricing campaigns: strategy: change period'
}

export class SettingsPricingCampaignsTableDuplicatePCs implements BaseEvent {
	event_type = 'settings: pricing campaigns: table: duplicate PCs'
}

export class SettingsPricingCampaignsTableSelectCopyOption implements BaseEvent {
	event_type = 'settings: pricing campaigns: table: select copy option'

	constructor(
		public event_properties?: SettingsPricingCampaignsTableSelectCopyOptionProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsTableSortBy implements BaseEvent {
	event_type = 'settings: pricing campaigns: table: sort by'

	constructor(
		public event_properties?: SettingsPricingCampaignsTableSortByProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPricingCampaignsViewClick implements BaseEvent {
	event_type = 'settings: pricing campaigns: view: click'

	constructor(
		public event_properties?: SettingsPricingCampaignsViewClickProperties
	) {
		this.event_properties = event_properties
	}
}

export class SettingsPromoCampaignsTableSortBy implements BaseEvent {
	event_type = 'settings: promo campaigns: table: sort by'

	constructor(
		public event_properties: SettingsPromoCampaignsTableSortByProperties
	) {
		this.event_properties = event_properties
	}
}

export class SkuSidebarOpened implements BaseEvent {
	event_type = 'sku sidebar: opened'
}

export class SkuSidebarTabClicked implements BaseEvent {
	event_type = 'sku sidebar: tab clicked'

	constructor(public event_properties?: SkuSidebarTabClickedProperties) {
		this.event_properties = event_properties
	}
}

export class TableAddQuickFilter implements BaseEvent {
	event_type = 'table: add quick filter'

	constructor(public event_properties?: TableAddQuickFilterProperties) {
		this.event_properties = event_properties
	}
}

export class TableAnchorApprovalApplyFilter implements BaseEvent {
	event_type = 'table: anchor approval: apply filter'
}

export class TableAnchorStrategyApplyFilter implements BaseEvent {
	event_type = 'table: anchor strategy: apply filter'
}

export class TableApplyLatestFilter implements BaseEvent {
	event_type = 'table: apply latest filter'
}

export class TableAssignToAnchors implements BaseEvent {
	event_type = 'table: assign to anchors'
}

export class TableAssignToAnchorsSave implements BaseEvent {
	event_type = 'table: assign to anchors: save'
}

export class TableAssignToPricingCampaign implements BaseEvent {
	event_type = 'table: assign to pricing campaign'

	constructor(
		public event_properties?: TableAssignToPricingCampaignProperties
	) {
		this.event_properties = event_properties
	}
}

export class TableClearQuickFilter implements BaseEvent {
	event_type = 'table: clear quick filter'

	constructor(public event_properties?: TableClearQuickFilterProperties) {
		this.event_properties = event_properties
	}
}

export class TableClearSelection implements BaseEvent {
	event_type = 'table: clear selection'
}

export class TableImportFromFile implements BaseEvent {
	event_type = 'table: import from file'

	constructor(public event_properties?: TableImportFromFileProperties) {
		this.event_properties = event_properties
	}
}

export class TableLockPrice implements BaseEvent {
	event_type = 'table: lock price'
}

export class TableManualUpdate implements BaseEvent {
	event_type = 'table: manual update'

	constructor(public event_properties?: TableManualUpdateProperties) {
		this.event_properties = event_properties
	}
}

export class TableNewPriceEditing implements BaseEvent {
	event_type = 'table: new price editing'

	constructor(public event_properties?: TableNewPriceEditingProperties) {
		this.event_properties = event_properties
	}
}

export class TableOpenSkuPanelMarket implements BaseEvent {
	event_type = 'table: open SKU panel: Market'
}

export class TableOpenSkuPanelPerformance implements BaseEvent {
	event_type = 'table: open SKU panel: Performance'
}

export class TableRemoveQuickFilter implements BaseEvent {
	event_type = 'table: remove quick filter'

	constructor(public event_properties?: TableRemoveQuickFilterProperties) {
		this.event_properties = event_properties
	}
}

export class TableSaveChanges implements BaseEvent {
	event_type = 'table: save changes'
}

export class TableSelectAllItemsOnAllPages implements BaseEvent {
	event_type = 'table: select all items on all pages'
}

export class TableUnassignFromPricingCampaigns implements BaseEvent {
	event_type = 'table: unassign from pricing campaigns'
}

export class TableUpdateQuickFilter implements BaseEvent {
	event_type = 'table: update quick filter'

	constructor(public event_properties?: TableUpdateQuickFilterProperties) {
		this.event_properties = event_properties
	}
}

export class ThemeSwitchToDarkMode implements BaseEvent {
	event_type = 'theme: switch to dark mode'
}

export class ThemeSwitchToLightMode implements BaseEvent {
	event_type = 'theme: switch to light mode'
}

export class ThemeSwitchToSystemMode implements BaseEvent {
	event_type = 'theme: switch to system mode'
}

export class VideoTutorialsClose implements BaseEvent {
	event_type = 'video tutorials: close'

	constructor(public event_properties?: VideoTutorialsCloseProperties) {
		this.event_properties = event_properties
	}
}

export class VideoTutorialsOpen implements BaseEvent {
	event_type = 'video tutorials: open'

	constructor(public event_properties?: VideoTutorialsOpenProperties) {
		this.event_properties = event_properties
	}
}

export class VideoTutorialsWatch implements BaseEvent {
	event_type = 'video tutorials: watch'

	constructor(public event_properties?: VideoTutorialsWatchProperties) {
		this.event_properties = event_properties
	}
}

export class WhatIfCompareClicked implements BaseEvent {
	event_type = 'what-if: compare: clicked'

	constructor(public event_properties: WhatIfCompareClickedProperties) {
		this.event_properties = event_properties
	}
}

export class WhatIfCreateScenarioModalOpen implements BaseEvent {
	event_type = 'what-if: create scenario: modal: open'

	constructor(
		public event_properties?: WhatIfCreateScenarioModalOpenProperties
	) {
		this.event_properties = event_properties
	}
}

export class WhatIfCreateScenarioModalSubmit implements BaseEvent {
	event_type = 'what-if: create scenario: modal: submit'
}

export class WhatIfDuplicatePcsToScenarioModalOpen implements BaseEvent {
	event_type = 'what-if: duplicate pcs to scenario: modal: open'

	constructor(
		public event_properties?: WhatIfDuplicatePcsToScenarioModalOpenProperties
	) {
		this.event_properties = event_properties
	}
}

export class WhatIfDuplicatePcsToScenarioModalSubmit implements BaseEvent {
	event_type = 'what-if: duplicate pcs to scenario: modal: submit'

	constructor(
		public event_properties?: WhatIfDuplicatePcsToScenarioModalSubmitProperties
	) {
		this.event_properties = event_properties
	}
}

export class WhatIfRestarted implements BaseEvent {
	event_type = 'what-if: restarted'
}

export class WhatIfRunsSetActionClicked implements BaseEvent {
	event_type = 'what-if: runs set: action clicked'

	constructor(public event_properties: WhatIfRunsSetActionClickedProperties) {
		this.event_properties = event_properties
	}
}

export class WhatIfScenarioEditClicked implements BaseEvent {
	event_type = 'what-if: scenario: edit clicked'
}

export class WhatIfScenarioRenameClicked implements BaseEvent {
	event_type = 'what-if: scenario: rename clicked'
}

export class WhatIfSummaryChartTabClicked implements BaseEvent {
	event_type = 'what-if: summary: chart tab clicked'

	constructor(
		public event_properties?: WhatIfSummaryChartTabClickedProperties
	) {
		this.event_properties = event_properties
	}
}

export class WhatIfSummaryDeleteRow implements BaseEvent {
	event_type = 'what-if: summary: delete row'
}

export class WhatIfSummaryDownloadReport implements BaseEvent {
	event_type = 'what-if: summary: download report'
}

export class WhatIfSummaryDuplicateClicked implements BaseEvent {
	event_type = 'what-if: summary: duplicate clicked'
}

export class WhatIfSummaryPromoteClicked implements BaseEvent {
	event_type = 'what-if: summary: promote clicked'
}

export class WhatIfSummaryReRun implements BaseEvent {
	event_type = 'what-if: summary: re-run'
}

export class WhatIfSummaryRun implements BaseEvent {
	event_type = 'what-if: summary: run'

	constructor(public event_properties?: WhatIfSummaryRunProperties) {
		this.event_properties = event_properties
	}
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * ai: chat: clicked suggestion
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/ai%3A%20chat%3A%20clicked%20suggestion)
   *
   * Tracks when a user selects a suggested response or option within the AI chat interface, indicating engagement with automated recommendations.
   *
   * @param properties The event's properties (e.g. suggestion)
   * @param options Amplitude event options.
   */
  aiChatClickedSuggestion(
    properties?: AiChatClickedSuggestionProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiChatClickedSuggestion(properties), options);
  }

  /**
   * ai: chat: closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/ai%3A%20chat%3A%20closed)
   *
   * Tracks when a user closes an "AI chat panel" feature.
   *
   * @param options Amplitude event options.
   */
  aiChatClosed(
    options?: EventOptions,
  ) {
    return this.track(new AiChatClosed(), options);
  }

  /**
   * ai: chat: opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/ai%3A%20chat%3A%20opened)
   *
   * Tracks when a user opens an "AI chat panel" feature.
   *
   * @param options Amplitude event options.
   */
  aiChatOpened(
    options?: EventOptions,
  ) {
    return this.track(new AiChatOpened(), options);
  }

  /**
   * ai: chat: reset conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/ai%3A%20chat%3A%20reset%20conversation)
   *
   * Indicates the user has cleared the current AI chat session, removing all previous messages and starting a new conversation thread.
   *
   * @param options Amplitude event options.
   */
  aiChatResetConversation(
    options?: EventOptions,
  ) {
    return this.track(new AiChatResetConversation(), options);
  }

  /**
   * ai: chat: sent user message
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/ai%3A%20chat%3A%20sent%20user%20message)
   *
   * Records the content and timestamp when a user submits a message to the AI chat interface.
   *
   * @param options Amplitude event options.
   */
  aiChatSentUserMessage(
    options?: EventOptions,
  ) {
    return this.track(new AiChatSentUserMessage(), options);
  }

  /**
   * alerts: anchoring: click open sidebar
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20anchoring%3A%20click%20open%20sidebar)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  alertsAnchoringClickOpenSidebar(
    options?: EventOptions,
  ) {
    return this.track(new AlertsAnchoringClickOpenSidebar(), options);
  }

  /**
   * alerts: anchoring: hit show notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20anchoring%3A%20hit%20show%20notification)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsAnchoringHitShowNotification(
    properties?: AlertsAnchoringHitShowNotificationProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsAnchoringHitShowNotification(properties), options);
  }

  /**
   * alerts: assortment: click open sidebar
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20assortment%3A%20click%20open%20sidebar)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  alertsAssortmentClickOpenSidebar(
    options?: EventOptions,
  ) {
    return this.track(new AlertsAssortmentClickOpenSidebar(), options);
  }

  /**
   * alerts: assortment: hit show notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20assortment%3A%20hit%20show%20notification)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsAssortmentHitShowNotification(
    properties?: AlertsAssortmentHitShowNotificationProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsAssortmentHitShowNotification(properties), options);
  }

  /**
   * alerts: assortment: hit show notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20assortment%3A%20hit%20show%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsAssortmentHitShowNotifications(
    properties?: AlertsAssortmentHitShowNotificationsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsAssortmentHitShowNotifications(properties), options);
  }

  /**
   * alerts: assortment: hit the list of notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20assortment%3A%20hit%20the%20list%20of%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  alertsAssortmentHitTheListOfNotifications(
    options?: EventOptions,
  ) {
    return this.track(new AlertsAssortmentHitTheListOfNotifications(), options);
  }

  /**
   * alerts: item: badge: clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20item%3A%20badge%3A%20clicked)
   *
   * This event is triggered when a user clicks on a badge associated with an item within the alerts section. It captures the interaction to track user engagement with specific alert badges in the platform.
   *
   * @param properties The event's properties (e.g. alert_kind)
   * @param options Amplitude event options.
   */
  alertsItemBadgeClicked(
    properties: AlertsItemBadgeClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsItemBadgeClicked(properties), options);
  }

  /**
   * alerts: og: click open sidebar
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20og%3A%20click%20open%20sidebar)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  alertsOgClickOpenSidebar(
    options?: EventOptions,
  ) {
    return this.track(new AlertsOgClickOpenSidebar(), options);
  }

  /**
   * alerts: og: click show solution
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20og%3A%20click%20show%20solution)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  alertsOgClickShowSolution(
    options?: EventOptions,
  ) {
    return this.track(new AlertsOgClickShowSolution(), options);
  }

  /**
   * alerts: og: hit show notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20og%3A%20hit%20show%20notification)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsOgHitShowNotification(
    properties?: AlertsOgHitShowNotificationProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsOgHitShowNotification(properties), options);
  }

  /**
   * alerts: og: hit show notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20og%3A%20hit%20show%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsOgHitShowNotifications(
    properties?: AlertsOgHitShowNotificationsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsOgHitShowNotifications(properties), options);
  }

  /**
   * alerts: og: hit the list of notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20og%3A%20hit%20the%20list%20of%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  alertsOgHitTheListOfNotifications(
    options?: EventOptions,
  ) {
    return this.track(new AlertsOgHitTheListOfNotifications(), options);
  }

  /**
   * alerts: open clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20open%20clicked)
   *
   * This event is triggered when a user clicks to open a notification alert  sidebar.
   *
   * @param properties The event's properties (e.g. alerts_of)
   * @param options Amplitude event options.
   */
  alertsOpenClicked(
    properties: AlertsOpenClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsOpenClicked(properties), options);
  }

  /**
   * alerts: pc: hit show notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20pc%3A%20hit%20show%20notification)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsPcHitShowNotification(
    properties?: AlertsPcHitShowNotificationProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsPcHitShowNotification(properties), options);
  }

  /**
   * alerts: pc: hit show notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20pc%3A%20hit%20show%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsPcHitShowNotifications(
    properties?: AlertsPcHitShowNotificationsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsPcHitShowNotifications(properties), options);
  }

  /**
   * alerts: pc: hit the list of notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20pc%3A%20hit%20the%20list%20of%20notifications)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  alertsPcHitTheListOfNotifications(
    options?: EventOptions,
  ) {
    return this.track(new AlertsPcHitTheListOfNotifications(), options);
  }

  /**
   * alerts: products: hit show notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20products%3A%20hit%20show%20notification)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsProductsHitShowNotification(
    properties?: AlertsProductsHitShowNotificationProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsProductsHitShowNotification(properties), options);
  }

  /**
   * alerts: products: hit show notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20products%3A%20hit%20show%20notifications)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. kind)
   * @param options Amplitude event options.
   */
  alertsProductsHitShowNotifications(
    properties?: AlertsProductsHitShowNotificationsProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsProductsHitShowNotifications(properties), options);
  }

  /**
   * alerts: products: hit the list of notifications
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20products%3A%20hit%20the%20list%20of%20notifications)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  alertsProductsHitTheListOfNotifications(
    options?: EventOptions,
  ) {
    return this.track(new AlertsProductsHitTheListOfNotifications(), options);
  }

  /**
   * alerts: section: toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20section%3A%20toggled)
   *
   * This event represents a user toggling the visibility of a specific section within the Alerts interface. It is triggered whenever the section is expanded or collapsed by the user.
   *
   * @param properties The event's properties (e.g. alert_kind)
   * @param options Amplitude event options.
   */
  alertsSectionToggled(
    properties: AlertsSectionToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsSectionToggled(properties), options);
  }

  /**
   * alerts: view solution: clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/alerts%3A%20view%20solution%3A%20clicked)
   *
   * This event captures when a user clicks on the "View Solution" option within the alerts section. It is triggered at the moment the user initiates this action to explore recommended solutions for a specific alert.
   *
   * @param properties The event's properties (e.g. alert_kind)
   * @param options Amplitude event options.
   */
  alertsViewSolutionClicked(
    properties: AlertsViewSolutionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AlertsViewSolutionClicked(properties), options);
  }

  /**
   * anchor strategy: open: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchor%20strategy%3A%20open%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. id)
   * @param options Amplitude event options.
   */
  anchorStrategyOpenClick(
    properties?: AnchorStrategyOpenClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new AnchorStrategyOpenClick(properties), options);
  }

  /**
   * anchoring-management: create anchor strategy
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring-management%3A%20create%20anchor%20strategy)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  anchoringManagementCreateAnchorStrategy(
    properties?: AnchoringManagementCreateAnchorStrategyProperties,
    options?: EventOptions,
  ) {
    return this.track(new AnchoringManagementCreateAnchorStrategy(properties), options);
  }

  /**
   * anchoring: anchor approval: click approve
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20approval%3A%20click%20approve)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorApprovalClickApprove(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorApprovalClickApprove(), options);
  }

  /**
   * anchoring: anchor approval: click approve all
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20approval%3A%20click%20approve%20all)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorApprovalClickApproveAll(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorApprovalClickApproveAll(), options);
  }

  /**
   * anchoring: anchor approval: click reject
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20approval%3A%20click%20reject)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorApprovalClickReject(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorApprovalClickReject(), options);
  }

  /**
   * anchoring: anchor approval: click reject all
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20approval%3A%20click%20reject%20all)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorApprovalClickRejectAll(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorApprovalClickRejectAll(), options);
  }

  /**
   * anchoring: anchor strategy: add aggregation
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20add%20aggregation)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyAddAggregation(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyAddAggregation(), options);
  }

  /**
   * anchoring: anchor strategy: add family
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20add%20family)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyAddFamily(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyAddFamily(), options);
  }

  /**
   * anchoring: anchor strategy: add family filters
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20add%20family%20filters)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filters_value)
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyAddFamilyFilters(
    properties?: AnchoringAnchorStrategyAddFamilyFiltersProperties,
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyAddFamilyFilters(properties), options);
  }

  /**
   * anchoring: anchor strategy: add price column
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20add%20price%20column)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyAddPriceColumn(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyAddPriceColumn(), options);
  }

  /**
   * anchoring: anchor strategy: open families
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20open%20families)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyOpenFamilies(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyOpenFamilies(), options);
  }

  /**
   * anchoring: anchor strategy: open general
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20open%20general)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyOpenGeneral(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyOpenGeneral(), options);
  }

  /**
   * anchoring: anchor strategy: open price distance
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20open%20price%20distance)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyOpenPriceDistance(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyOpenPriceDistance(), options);
  }

  /**
   * anchoring: anchor strategy: update aggregation rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20anchor%20strategy%3A%20update%20aggregation%20rule)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_value)
   * @param options Amplitude event options.
   */
  anchoringAnchorStrategyUpdateAggregationRule(
    properties?: AnchoringAnchorStrategyUpdateAggregationRuleProperties,
    options?: EventOptions,
  ) {
    return this.track(new AnchoringAnchorStrategyUpdateAggregationRule(properties), options);
  }

  /**
   * anchoring: apply filters
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20apply%20filters)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringApplyFilters(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringApplyFilters(), options);
  }

  /**
   * anchoring: delete selected rows: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20delete%20selected%20rows%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringDeleteSelectedRowsClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringDeleteSelectedRowsClick(), options);
  }

  /**
   * anchoring: export table: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20export%20table%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringExportTableClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringExportTableClick(), options);
  }

  /**
   * anchoring: export: download
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20export%3A%20download)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringExportDownload(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringExportDownload(), options);
  }

  /**
   * anchoring: import from file: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20import%20from%20file%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringImportFromFileClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringImportFromFileClick(), options);
  }

  /**
   * anchoring: import from file: download template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20import%20from%20file%3A%20download%20template)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringImportFromFileDownloadTemplate(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringImportFromFileDownloadTemplate(), options);
  }

  /**
   * anchoring: import from file: upload
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20import%20from%20file%3A%20upload)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringImportFromFileUpload(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringImportFromFileUpload(), options);
  }

  /**
   * anchoring: revert manual changes: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20revert%20manual%20changes%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringRevertManualChangesClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringRevertManualChangesClick(), options);
  }

  /**
   * anchoring: save manual changes: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20save%20manual%20changes%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringSaveManualChangesClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringSaveManualChangesClick(), options);
  }

  /**
   * anchoring: table: count: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20table%3A%20count%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringTableCountClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringTableCountClick(), options);
  }

  /**
   * anchoring: table: create anchor
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20table%3A%20create%20anchor)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringTableCreateAnchor(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringTableCreateAnchor(), options);
  }

  /**
   * anchoring: table: create anchor: save
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20table%3A%20create%20anchor%3A%20save)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringTableCreateAnchorSave(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringTableCreateAnchorSave(), options);
  }

  /**
   * anchoring: table: sku: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20table%3A%20sku%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  anchoringTableSkuClick(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringTableSkuClick(), options);
  }

  /**
   * anchoring: view anchor strategy
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/anchoring%3A%20view%20anchor%20strategy)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  anchoringViewAnchorStrategy(
    options?: EventOptions,
  ) {
    return this.track(new AnchoringViewAnchorStrategy(), options);
  }

  /**
   * approval: create review
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/approval%3A%20create%20review)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Notify author)
   * @param options Amplitude event options.
   */
  approvalCreateReview(
    properties?: ApprovalCreateReviewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApprovalCreateReview(properties), options);
  }

  /**
   * approval: open review manager modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/approval%3A%20open%20review%20manager%20modal)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  approvalOpenReviewManagerModal(
    options?: EventOptions,
  ) {
    return this.track(new ApprovalOpenReviewManagerModal(), options);
  }

  /**
   * autorun: Create schedule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/autorun%3A%20Create%20schedule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. amount of notif users)
   * @param options Amplitude event options.
   */
  autorunCreateSchedule(
    properties?: AutorunCreateScheduleProperties,
    options?: EventOptions,
  ) {
    return this.track(new AutorunCreateSchedule(properties), options);
  }

  /**
   * autorun: Delete schedule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/autorun%3A%20Delete%20schedule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. configuration name)
   * @param options Amplitude event options.
   */
  autorunDeleteSchedule(
    properties?: AutorunDeleteScheduleProperties,
    options?: EventOptions,
  ) {
    return this.track(new AutorunDeleteSchedule(properties), options);
  }

  /**
   * autorun: Filter scheduled OGs
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/autorun%3A%20Filter%20scheduled%20OGs)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  autorunFilterScheduledOGs(
    options?: EventOptions,
  ) {
    return this.track(new AutorunFilterScheduledOGs(), options);
  }

  /**
   * autorun: Update schedule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/autorun%3A%20Update%20schedule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. configuration name)
   * @param options Amplitude event options.
   */
  autorunUpdateSchedule(
    properties?: AutorunUpdateScheduleProperties,
    options?: EventOptions,
  ) {
    return this.track(new AutorunUpdateSchedule(properties), options);
  }

  /**
   * browse: ai dashboard
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20ai%20dashboard)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseAiDashboard(
    options?: EventOptions,
  ) {
    return this.track(new BrowseAiDashboard(), options);
  }

  /**
   * browse: anchor approval
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20anchor%20approval)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  browseAnchorApproval(
    options?: EventOptions,
  ) {
    return this.track(new BrowseAnchorApproval(), options);
  }

  /**
   * browse: anchor strategy
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20anchor%20strategy)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  browseAnchorStrategy(
    options?: EventOptions,
  ) {
    return this.track(new BrowseAnchorStrategy(), options);
  }

  /**
   * browse: anchoring management assortment
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20anchoring%20management%20assortment)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseAnchoringManagementAssortment(
    options?: EventOptions,
  ) {
    return this.track(new BrowseAnchoringManagementAssortment(), options);
  }

  /**
   * browse: dashboard
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20dashboard)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseDashboard(
    options?: EventOptions,
  ) {
    return this.track(new BrowseDashboard(), options);
  }

  /**
   * browse: logout
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20logout)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseLogout(
    options?: EventOptions,
  ) {
    return this.track(new BrowseLogout(), options);
  }

  /**
   * browse: og list
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20og%20list)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Data freshness)
   * @param options Amplitude event options.
   */
  browseOgList(
    properties?: BrowseOgListProperties,
    options?: EventOptions,
  ) {
    return this.track(new BrowseOgList(properties), options);
  }

  /**
   * browse: pricing campaigns
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20pricing%20campaigns)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browsePricingCampaigns(
    options?: EventOptions,
  ) {
    return this.track(new BrowsePricingCampaigns(), options);
  }

  /**
   * browse: product assortment
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20product%20assortment)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseProductAssortment(
    options?: EventOptions,
  ) {
    return this.track(new BrowseProductAssortment(), options);
  }

  /**
   * browse: saved reports
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/browse%3A%20saved%20reports)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  browseSavedReports(
    options?: EventOptions,
  ) {
    return this.track(new BrowseSavedReports(), options);
  }

  /**
   * builder: drop
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/builder%3A%20drop)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. template_type)
   * @param options Amplitude event options.
   */
  builderDrop(
    properties?: BuilderDropProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuilderDrop(properties), options);
  }

  /**
   * builder: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/builder%3A%20open)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  builderOpen(
    options?: EventOptions,
  ) {
    return this.track(new BuilderOpen(), options);
  }

  /**
   * builder: reset
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/builder%3A%20reset)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  builderReset(
    options?: EventOptions,
  ) {
    return this.track(new BuilderReset(), options);
  }

  /**
   * builder: save
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/builder%3A%20save)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. is_new)
   * @param options Amplitude event options.
   */
  builderSave(
    properties?: BuilderSaveProperties,
    options?: EventOptions,
  ) {
    return this.track(new BuilderSave(properties), options);
  }

  /**
   * columns: order: changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/columns%3A%20order%3A%20changed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  columnsOrderChanged(
    options?: EventOptions,
  ) {
    return this.track(new ColumnsOrderChanged(), options);
  }

  /**
   * command: execute
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/command%3A%20execute)
   *
   * This event represents the execution of a specific command within the Platform application, initiated either by a user action or an automated process.
   *
   * @param properties The event's properties (e.g. command_category)
   * @param options Amplitude event options.
   */
  commandExecute(
    properties: CommandExecuteProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommandExecute(properties), options);
  }

  /**
   * create og: close modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/create%20og%3A%20close%20modal)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  createOgCloseModal(
    options?: EventOptions,
  ) {
    return this.track(new CreateOgCloseModal(), options);
  }

  /**
   * create og: go next step
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/create%20og%3A%20go%20next%20step)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  createOgGoNextStep(
    options?: EventOptions,
  ) {
    return this.track(new CreateOgGoNextStep(), options);
  }

  /**
   * create og: go prev step
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/create%20og%3A%20go%20prev%20step)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  createOgGoPrevStep(
    options?: EventOptions,
  ) {
    return this.track(new CreateOgGoPrevStep(), options);
  }

  /**
   * create og: submit form
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/create%20og%3A%20submit%20form)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  createOgSubmitForm(
    options?: EventOptions,
  ) {
    return this.track(new CreateOgSubmitForm(), options);
  }

  /**
   * dashboard: bi: additional metrics choise for historical graph
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20additional%20metrics%20choise%20for%20historical%20graph)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardBiAdditionalMetricsChoiseForHistoricalGraph(
    properties?: DashboardBiAdditionalMetricsChoiseForHistoricalGraphProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiAdditionalMetricsChoiseForHistoricalGraph(properties), options);
  }

  /**
   * dashboard: bi: apply filter HistoricalPriceAcceptance
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20HistoricalPriceAcceptance)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterHistoricalPriceAcceptance(
    properties?: DashboardBiApplyFilterHistoricalPriceAcceptanceProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterHistoricalPriceAcceptance(properties), options);
  }

  /**
   * dashboard: bi: apply filter MetricsByBrand
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20MetricsByBrand)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterMetricsByBrand(
    properties?: DashboardBiApplyFilterMetricsByBrandProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterMetricsByBrand(properties), options);
  }

  /**
   * dashboard: bi: apply filter MetricsByOptimizationGroup
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20MetricsByOptimizationGroup)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterMetricsByOptimizationGroup(
    properties?: DashboardBiApplyFilterMetricsByOptimizationGroupProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterMetricsByOptimizationGroup(properties), options);
  }

  /**
   * dashboard: bi: apply filter MetricsByPricingCampaign
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20MetricsByPricingCampaign)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterMetricsByPricingCampaign(
    properties?: DashboardBiApplyFilterMetricsByPricingCampaignProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterMetricsByPricingCampaign(properties), options);
  }

  /**
   * dashboard: bi: apply filter OptimizationHistoryDonut
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20OptimizationHistoryDonut)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterOptimizationHistoryDonut(
    properties?: DashboardBiApplyFilterOptimizationHistoryDonutProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterOptimizationHistoryDonut(properties), options);
  }

  /**
   * dashboard: bi: apply filter OptimizationHistoryTable
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20OptimizationHistoryTable)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterOptimizationHistoryTable(
    properties?: DashboardBiApplyFilterOptimizationHistoryTableProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterOptimizationHistoryTable(properties), options);
  }

  /**
   * dashboard: bi: apply filter RepricedByPricingEngine
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20RepricedByPricingEngine)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterRepricedByPricingEngine(
    properties?: DashboardBiApplyFilterRepricedByPricingEngineProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterRepricedByPricingEngine(properties), options);
  }

  /**
   * dashboard: bi: apply filter RevenueUnderManagementByEngine
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20RevenueUnderManagementByEngine)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterRevenueUnderManagementByEngine(
    properties?: DashboardBiApplyFilterRevenueUnderManagementByEngineProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterRevenueUnderManagementByEngine(properties), options);
  }

  /**
   * dashboard: bi: apply filter RevenueUnderManagementByPriceChange
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20RevenueUnderManagementByPriceChange)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterRevenueUnderManagementByPriceChange(
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterRevenueUnderManagementByPriceChange(), options);
  }

  /**
   * dashboard: bi: apply filter SalesFactorsImpact
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20SalesFactorsImpact)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filter by)
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterSalesFactorsImpact(
    properties?: DashboardBiApplyFilterSalesFactorsImpactProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterSalesFactorsImpact(properties), options);
  }

  /**
   * dashboard: bi: apply filter SalesFactorsImpactByCategories
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20SalesFactorsImpactByCategories)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterSalesFactorsImpactByCategories(
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterSalesFactorsImpactByCategories(), options);
  }

  /**
   * dashboard: bi: apply filter SalesFactorsImpactDynamic
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20apply%20filter%20SalesFactorsImpactDynamic)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  dashboardBiApplyFilterSalesFactorsImpactDynamic(
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiApplyFilterSalesFactorsImpactDynamic(), options);
  }

  /**
   * dashboard: bi: main metric choice for historical graph
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20main%20metric%20choice%20for%20historical%20graph)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. metric)
   * @param options Amplitude event options.
   */
  dashboardBiMainMetricChoiceForHistoricalGraph(
    properties: DashboardBiMainMetricChoiceForHistoricalGraphProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiMainMetricChoiceForHistoricalGraph(properties), options);
  }

  /**
   * dashboard: bi: proceed to product warnings
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20proceed%20to%20product%20warnings)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  dashboardBiProceedToProductWarnings(
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiProceedToProductWarnings(), options);
  }

  /**
   * dashboard: bi: proceed to unassigned list
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20proceed%20to%20unassigned%20list)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  dashboardBiProceedToUnassignedList(
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiProceedToUnassignedList(), options);
  }

  /**
   * dashboard: bi: switch revenue period in metric to compare
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/dashboard%3A%20bi%3A%20switch%20revenue%20period%20in%20metric%20to%20compare)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  dashboardBiSwitchRevenuePeriodInMetricToCompare(
    properties: DashboardBiSwitchRevenuePeriodInMetricToCompareProperties,
    options?: EventOptions,
  ) {
    return this.track(new DashboardBiSwitchRevenuePeriodInMetricToCompare(properties), options);
  }

  /**
   * error: error displayed
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/error%3A%20error%20displayed)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  errorErrorDisplayed(
    options?: EventOptions,
  ) {
    return this.track(new ErrorErrorDisplayed(), options);
  }

  /**
   * export: modal: create export
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20modal%3A%20create%20export)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. aggregation)
   * @param options Amplitude event options.
   */
  exportModalCreateExport(
    properties?: ExportModalCreateExportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportModalCreateExport(properties), options);
  }

  /**
   * export: params: change type
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20change%20type)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. export_kind)
   * @param options Amplitude event options.
   */
  exportParamsChangeType(
    properties?: ExportParamsChangeTypeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsChangeType(properties), options);
  }

  /**
   * export: params: fields configuration: back
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20fields%20configuration%3A%20back)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. export_kind)
   * @param options Amplitude event options.
   */
  exportParamsFieldsConfigurationBack(
    properties?: ExportParamsFieldsConfigurationBackProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsFieldsConfigurationBack(properties), options);
  }

  /**
   * export: params: fields configuration: change field name
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20fields%20configuration%3A%20change%20field%20name)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. export_kind)
   * @param options Amplitude event options.
   */
  exportParamsFieldsConfigurationChangeFieldName(
    properties?: ExportParamsFieldsConfigurationChangeFieldNameProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsFieldsConfigurationChangeFieldName(properties), options);
  }

  /**
   * export: params: fields configuration: change field ref
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20fields%20configuration%3A%20change%20field%20ref)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field)
   * @param options Amplitude event options.
   */
  exportParamsFieldsConfigurationChangeFieldRef(
    properties: ExportParamsFieldsConfigurationChangeFieldRefProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsFieldsConfigurationChangeFieldRef(properties), options);
  }

  /**
   * export: params: fields configuration: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20fields%20configuration%3A%20open)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. export_kind)
   * @param options Amplitude event options.
   */
  exportParamsFieldsConfigurationOpen(
    properties?: ExportParamsFieldsConfigurationOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsFieldsConfigurationOpen(properties), options);
  }

  /**
   * export: params: fields configuration: toggle visability
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20fields%20configuration%3A%20toggle%20visability)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  exportParamsFieldsConfigurationToggleVisability(
    properties?: ExportParamsFieldsConfigurationToggleVisabilityProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsFieldsConfigurationToggleVisability(properties), options);
  }

  /**
   * export: params: set params
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/export%3A%20params%3A%20set%20params)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. aggregation)
   * @param options Amplitude event options.
   */
  exportParamsSetParams(
    properties?: ExportParamsSetParamsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportParamsSetParams(properties), options);
  }

  /**
   * exports: delete export
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/exports%3A%20delete%20export)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  exportsDeleteExport(
    options?: EventOptions,
  ) {
    return this.track(new ExportsDeleteExport(), options);
  }

  /**
   * global assortment: apply filters
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20assortment%3A%20apply%20filters)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  globalAssortmentApplyFilters(
    options?: EventOptions,
  ) {
    return this.track(new GlobalAssortmentApplyFilters(), options);
  }

  /**
   * global assortment: download assortment report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20assortment%3A%20download%20assortment%20report)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  globalAssortmentDownloadAssortmentReport(
    options?: EventOptions,
  ) {
    return this.track(new GlobalAssortmentDownloadAssortmentReport(), options);
  }

  /**
   * global pc set: action clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%20set%3A%20action%20clicked)
   *
   * This event records when a user clicks on an action within the global price checker (PC) interface. It is triggered immediately upon the user's interaction with any actionable item in the global PC section of the Platform PROD application.
   *
   * @param properties The event's properties (e.g. global_pc_set_action)
   * @param options Amplitude event options.
   */
  globalPcSetActionClicked(
    properties: GlobalPcSetActionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcSetActionClicked(properties), options);
  }

  /**
   * global pc set: comparison: action clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%20set%3A%20comparison%3A%20action%20clicked)
   *
   * This event captures when a user clicks an action within the  comparison feature of the What-if module.
   *
   * @param properties The event's properties (e.g. global_pc_set_comparison_action)
   * @param options Amplitude event options.
   */
  globalPcSetComparisonActionClicked(
    properties: GlobalPcSetComparisonActionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcSetComparisonActionClicked(properties), options);
  }

  /**
   * global pc set: create clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%20set%3A%20create%20clicked)
   *
   * This event records when a user clicks the "Create" button to initiate a new global price comparison set within the What-if category. It is triggered at the moment the user confirms the creation action in the Platform PROD interface.
   *
   * @param options Amplitude event options.
   */
  globalPcSetCreateClicked(
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcSetCreateClicked(), options);
  }

  /**
   * global pc: confirmation modal: confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%3A%20confirmation%20modal%3A%20confirm)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  globalPcConfirmationModalConfirm(
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcConfirmationModalConfirm(), options);
  }

  /**
   * global pc: confirmation modal: navigate to OG
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%3A%20confirmation%20modal%3A%20navigate%20to%20OG)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  globalPcConfirmationModalNavigateToOg(
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcConfirmationModalNavigateToOg(), options);
  }

  /**
   * global pc: confirmation modal: revoke OG
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20pc%3A%20confirmation%20modal%3A%20revoke%20OG)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. status)
   * @param options Amplitude event options.
   */
  globalPcConfirmationModalRevokeOg(
    properties: GlobalPcConfirmationModalRevokeOgProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlobalPcConfirmationModalRevokeOg(properties), options);
  }

  /**
   * global products: assign to anchors
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global%20products%3A%20assign%20to%20anchors)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  globalProductsAssignToAnchors(
    options?: EventOptions,
  ) {
    return this.track(new GlobalProductsAssignToAnchors(), options);
  }

  /**
   * global-assortment: save changes
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/global-assortment%3A%20save%20changes)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  globalAssortmentSaveChanges(
    properties?: GlobalAssortmentSaveChangesProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlobalAssortmentSaveChanges(properties), options);
  }

  /**
   * jsd: create ticket: open intercom
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/jsd%3A%20create%20ticket%3A%20open%20intercom)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  jsdCreateTicketOpenIntercom(
    options?: EventOptions,
  ) {
    return this.track(new JsdCreateTicketOpenIntercom(), options);
  }

  /**
   * jsd: create ticket: open modal
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/jsd%3A%20create%20ticket%3A%20open%20modal)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  jsdCreateTicketOpenModal(
    options?: EventOptions,
  ) {
    return this.track(new JsdCreateTicketOpenModal(), options);
  }

  /**
   * jsd: create ticket: submit form
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/jsd%3A%20create%20ticket%3A%20submit%20form)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. attachments)
   * @param options Amplitude event options.
   */
  jsdCreateTicketSubmitForm(
    properties?: JsdCreateTicketSubmitFormProperties,
    options?: EventOptions,
  ) {
    return this.track(new JsdCreateTicketSubmitForm(properties), options);
  }

  /**
   * mass repricing: action: apply
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20apply)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionApply(
    properties?: MassRepricingActionApplyProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionApply(properties), options);
  }

  /**
   * mass repricing: action: discard
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20discard)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  massRepricingActionDiscard(
    properties?: MassRepricingActionDiscardProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionDiscard(properties), options);
  }

  /**
   * mass repricing: action: export prices
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20export%20prices)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionExportPrices(
    properties?: MassRepricingActionExportPricesProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionExportPrices(properties), options);
  }

  /**
   * mass repricing: action: pending
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20pending)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionPending(
    properties?: MassRepricingActionPendingProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionPending(properties), options);
  }

  /**
   * mass repricing: action: restart
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20restart)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionRestart(
    properties?: MassRepricingActionRestartProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionRestart(properties), options);
  }

  /**
   * mass repricing: action: revert
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20revert)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  massRepricingActionRevert(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionRevert(), options);
  }

  /**
   * mass repricing: action: revoke
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20revoke)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionRevoke(
    properties?: MassRepricingActionRevokeProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionRevoke(properties), options);
  }

  /**
   * mass repricing: action: start
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20start)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionStart(
    properties?: MassRepricingActionStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionStart(properties), options);
  }

  /**
   * mass repricing: action: stop
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20action%3A%20stop)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Mass action by)
   * @param options Amplitude event options.
   */
  massRepricingActionStop(
    properties?: MassRepricingActionStopProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingActionStop(properties), options);
  }

  /**
   * mass repricing: filter: all
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20all)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterAll(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterAll(), options);
  }

  /**
   * mass repricing: filter: failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20failed)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterFailed(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterFailed(), options);
  }

  /**
   * mass repricing: filter: finished
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20finished)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterFinished(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterFinished(), options);
  }

  /**
   * mass repricing: filter: locked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20locked)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterLocked(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterLocked(), options);
  }

  /**
   * mass repricing: filter: new
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20new)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterNew(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterNew(), options);
  }

  /**
   * mass repricing: filter: pending
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20pending)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterPending(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterPending(), options);
  }

  /**
   * mass repricing: filter: started
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20filter%3A%20started)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingFilterStarted(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingFilterStarted(), options);
  }

  /**
   * mass repricing: search
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20search)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  massRepricingSearch(
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingSearch(), options);
  }

  /**
   * mass repricing: update data from file
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/mass%20repricing%3A%20update%20data%20from%20file)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Ignore empty fields)
   * @param options Amplitude event options.
   */
  massRepricingUpdateDataFromFile(
    properties?: MassRepricingUpdateDataFromFileProperties,
    options?: EventOptions,
  ) {
    return this.track(new MassRepricingUpdateDataFromFile(properties), options);
  }

  /**
   * navigation-prompt: cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/navigation-prompt%3A%20cancel)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  navigationPromptCancel(
    options?: EventOptions,
  ) {
    return this.track(new NavigationPromptCancel(), options);
  }

  /**
   * navigation-prompt: confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/navigation-prompt%3A%20confirm)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  navigationPromptConfirm(
    options?: EventOptions,
  ) {
    return this.track(new NavigationPromptConfirm(), options);
  }

  /**
   * navigation-prompt: show
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/navigation-prompt%3A%20show)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  navigationPromptShow(
    options?: EventOptions,
  ) {
    return this.track(new NavigationPromptShow(), options);
  }

  /**
   * og assortment: apply filters
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20assortment%3A%20apply%20filters)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogAssortmentApplyFilters(
    options?: EventOptions,
  ) {
    return this.track(new OgAssortmentApplyFilters(), options);
  }

  /**
   * og list: alerts by og: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20list%3A%20alerts%20by%20og%3A%20open)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  ogListAlertsByOgOpen(
    options?: EventOptions,
  ) {
    return this.track(new OgListAlertsByOgOpen(), options);
  }

  /**
   * og list: create og: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20list%3A%20create%20og%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogListCreateOgClick(
    options?: EventOptions,
  ) {
    return this.track(new OgListCreateOgClick(), options);
  }

  /**
   * og list: filters apply
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20list%3A%20filters%20apply)
   *
   * Records the application of advanced filters on the OGs grid list, capturing filter criteria.
   *
   * @param options Amplitude event options.
   */
  ogListFiltersApply(
    options?: EventOptions,
  ) {
    return this.track(new OgListFiltersApply(), options);
  }

  /**
   * og list: import from file: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20list%3A%20import%20from%20file%3A%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  ogListImportFromFileClick(
    options?: EventOptions,
  ) {
    return this.track(new OgListImportFromFileClick(), options);
  }

  /**
   * og settings: delete og
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20settings%3A%20delete%20og)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogSettingsDeleteOg(
    options?: EventOptions,
  ) {
    return this.track(new OgSettingsDeleteOg(), options);
  }

  /**
   * og settings: description modal: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20settings%3A%20description%20modal%3A%20open)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogSettingsDescriptionModalOpen(
    options?: EventOptions,
  ) {
    return this.track(new OgSettingsDescriptionModalOpen(), options);
  }

  /**
   * og settings: description modal: submit form
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20settings%3A%20description%20modal%3A%20submit%20form)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogSettingsDescriptionModalSubmitForm(
    options?: EventOptions,
  ) {
    return this.track(new OgSettingsDescriptionModalSubmitForm(), options);
  }

  /**
   * og settings: reset form
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20settings%3A%20reset%20form)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogSettingsResetForm(
    options?: EventOptions,
  ) {
    return this.track(new OgSettingsResetForm(), options);
  }

  /**
   * og settings: save scenario as template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%20settings%3A%20save%20scenario%20as%20template)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogSettingsSaveScenarioAsTemplate(
    options?: EventOptions,
  ) {
    return this.track(new OgSettingsSaveScenarioAsTemplate(), options);
  }

  /**
   * og: product list: new anchors badge: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%3A%20product%20list%3A%20new%20anchors%20badge%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  ogProductListNewAnchorsBadgeClick(
    options?: EventOptions,
  ) {
    return this.track(new OgProductListNewAnchorsBadgeClick(), options);
  }

  /**
   * og: view
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/og%3A%20view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. mode)
   * @param options Amplitude event options.
   */
  ogView(
    properties?: OgViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new OgView(properties), options);
  }

  /**
   * opt summary glob: items changed widget: click row
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%20glob%3A%20items%20changed%20widget%3A%20click%20row)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filters)
   * @param options Amplitude event options.
   */
  optSummaryGlobItemsChangedWidgetClickRow(
    properties?: OptSummaryGlobItemsChangedWidgetClickRowProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryGlobItemsChangedWidgetClickRow(properties), options);
  }

  /**
   * opt summary glob: open optimization tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%20glob%3A%20open%20optimization%20tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  optSummaryGlobOpenOptimizationTab(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryGlobOpenOptimizationTab(), options);
  }

  /**
   * opt summary glob: open statistics tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%20glob%3A%20open%20statistics%20tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  optSummaryGlobOpenStatisticsTab(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryGlobOpenStatisticsTab(), options);
  }

  /**
   * opt summary glob: promo widget: click row
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%20glob%3A%20promo%20widget%3A%20click%20row)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filters)
   * @param options Amplitude event options.
   */
  optSummaryGlobPromoWidgetClickRow(
    properties?: OptSummaryGlobPromoWidgetClickRowProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryGlobPromoWidgetClickRow(properties), options);
  }

  /**
   * opt summary glob: use table filters switch
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%20glob%3A%20use%20table%20filters%20switch)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  optSummaryGlobUseTableFiltersSwitch(
    properties: OptSummaryGlobUseTableFiltersSwitchProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryGlobUseTableFiltersSwitch(properties), options);
  }

  /**
   * opt summary: items changed widget: click row
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20items%20changed%20widget%3A%20click%20row)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. filters)
   * @param options Amplitude event options.
   */
  optSummaryItemsChangedWidgetClickRow(
    properties?: OptSummaryItemsChangedWidgetClickRowProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryItemsChangedWidgetClickRow(properties), options);
  }

  /**
   * opt summary: open optimization tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20open%20optimization%20tab)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  optSummaryOpenOptimizationTab(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryOpenOptimizationTab(), options);
  }

  /**
   * opt summary: open progress tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20open%20progress%20tab)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  optSummaryOpenProgressTab(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryOpenProgressTab(), options);
  }

  /**
   * opt summary: open statistics tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20open%20statistics%20tab)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  optSummaryOpenStatisticsTab(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryOpenStatisticsTab(), options);
  }

  /**
   * opt summary: promo widget: click row
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20promo%20widget%3A%20click%20row)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filters)
   * @param options Amplitude event options.
   */
  optSummaryPromoWidgetClickRow(
    properties?: OptSummaryPromoWidgetClickRowProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryPromoWidgetClickRow(properties), options);
  }

  /**
   * opt summary: use table filters switch
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20use%20table%20filters%20switch)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  optSummaryUseTableFiltersSwitch(
    properties: OptSummaryUseTableFiltersSwitchProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryUseTableFiltersSwitch(properties), options);
  }

  /**
   * opt summary: view
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/opt%20summary%3A%20view)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  optSummaryView(
    options?: EventOptions,
  ) {
    return this.track(new OptSummaryView(), options);
  }

  /**
   * pc reorder: priority save
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%20reorder%3A%20priority%20save)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. pcs_type)
   * @param options Amplitude event options.
   */
  pcReorderPrioritySave(
    properties?: PcReorderPrioritySaveProperties,
    options?: EventOptions,
  ) {
    return this.track(new PcReorderPrioritySave(properties), options);
  }

  /**
   * pc: apply template clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20apply%20template%20clicked)
   *
   * This event captures when a user clicks the "Apply Template" button.
   *
   * @param options Amplitude event options.
   */
  pcApplyTemplateClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcApplyTemplateClicked(), options);
  }

  /**
   * pc: copy clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20copy%20clicked)
   *
   * This event occurs when a user clicks the copy button.
   *
   * @param options Amplitude event options.
   */
  pcCopyClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcCopyClicked(), options);
  }

  /**
   * pc: copy settings clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20copy%20settings%20clicked)
   *
   * This event is triggered when a user clicks the option to copy pricing configuration settings.
   *
   * @param options Amplitude event options.
   */
  pcCopySettingsClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcCopySettingsClicked(), options);
  }

  /**
   * pc: delete clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20delete%20clicked)
   *
   * This event captures the user action of clicking the delete button within the Platform PROD interface. It is triggered immediately when a user initiates a delete command to remove an item or entry.
   *
   * @param options Amplitude event options.
   */
  pcDeleteClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcDeleteClicked(), options);
  }

  /**
   * pc: duplicate clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20duplicate%20clicked)
   *
   * This event is triggered when a user clicks the "Duplicate" button within the Platform PROD interface. .
   *
   * @param options Amplitude event options.
   */
  pcDuplicateClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcDuplicateClicked(), options);
  }

  /**
   * pc: duplicate to clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20duplicate%20to%20clicked)
   *
   * This event is triggered when a user clicks the "Duplicate To" option within the Platform PROD interface, indicating their intent to duplicate an item or configuration to a specified target. It captures the initiation of the duplication action by the user.
   *
   * @param options Amplitude event options.
   */
  pcDuplicateToClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcDuplicateToClicked(), options);
  }

  /**
   * pc: reassign clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20reassign%20clicked)
   *
   * This event records when a user clicks the "Reassign" button within the Platform PROD interface.
   *
   * @param options Amplitude event options.
   */
  pcReassignClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcReassignClicked(), options);
  }

  /**
   * pc: save as template clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20save%20as%20template%20clicked)
   *
   * This event represents the user clicking the "Save as Template" button.
   *
   * @param options Amplitude event options.
   */
  pcSaveAsTemplateClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcSaveAsTemplateClicked(), options);
  }

  /**
   * pc: save setting as template clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20save%20setting%20as%20template%20clicked)
   *
   * This event is triggered when a user clicks the option to save their current settings as a template .
   *
   * @param options Amplitude event options.
   */
  pcSaveSettingAsTemplateClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcSaveSettingAsTemplateClicked(), options);
  }

  /**
   * pc: setting changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20setting%20changed)
   *
   * This event records when a user modifies a configuration or preference within the PC settings. It is triggered immediately after a setting value is changed and saved.
   *
   * @param options Amplitude event options.
   */
  pcSettingChanged(
    options?: EventOptions,
  ) {
    return this.track(new PcSettingChanged(), options);
  }

  /**
   * pc: use settings template clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pc%3A%20use%20settings%20template%20clicked)
   *
   * This event is triggered when a user clicks on the "Use Settings Template" option within the Platform PROD interface.
   *
   * @param options Amplitude event options.
   */
  pcUseSettingsTemplateClicked(
    options?: EventOptions,
  ) {
    return this.track(new PcUseSettingsTemplateClicked(), options);
  }

  /**
   * pcs timeline: campaign name: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%20timeline%3A%20campaign%20name%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. destination)
   * @param options Amplitude event options.
   */
  pcsTimelineCampaignNameClick(
    properties?: PcsTimelineCampaignNameClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PcsTimelineCampaignNameClick(properties), options);
  }

  /**
   * pcs timeline: frequency: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%20timeline%3A%20frequency%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  pcsTimelineFrequencyClick(
    properties: PcsTimelineFrequencyClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PcsTimelineFrequencyClick(properties), options);
  }

  /**
   * pcs timeline: products count: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%20timeline%3A%20products%20count%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. destination)
   * @param options Amplitude event options.
   */
  pcsTimelineProductsCountClick(
    properties?: PcsTimelineProductsCountClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PcsTimelineProductsCountClick(properties), options);
  }

  /**
   * pcs timeline: view
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%20timeline%3A%20view)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pcsTimelineView(
    options?: EventOptions,
  ) {
    return this.track(new PcsTimelineView(), options);
  }

  /**
   * pcs: order: chnaged
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%3A%20order%3A%20chnaged)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  pcsOrderChnaged(
    options?: EventOptions,
  ) {
    return this.track(new PcsOrderChnaged(), options);
  }

  /**
   * pcs: pricing campaigns: alerts by pc: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pcs%3A%20pricing%20campaigns%3A%20alerts%20by%20pc%3A%20open)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  pcsPricingCampaignsAlertsByPcOpen(
    options?: EventOptions,
  ) {
    return this.track(new PcsPricingCampaignsAlertsByPcOpen(), options);
  }

  /**
   * preferences: update preferences
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/preferences%3A%20update%20preferences)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  preferencesUpdatePreferences(
    properties?: PreferencesUpdatePreferencesProperties,
    options?: EventOptions,
  ) {
    return this.track(new PreferencesUpdatePreferences(properties), options);
  }

  /**
   * pricing-campaign: settings example: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pricing-campaign%3A%20settings%20example%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  pricingCampaignSettingsExampleClick(
    properties?: PricingCampaignSettingsExampleClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new PricingCampaignSettingsExampleClick(properties), options);
  }

  /**
   * pricing-settings: anchoring: add anchor rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pricing-settings%3A%20anchoring%3A%20add%20anchor%20rule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  pricingSettingsAnchoringAddAnchorRule(
    options?: EventOptions,
  ) {
    return this.track(new PricingSettingsAnchoringAddAnchorRule(), options);
  }

  /**
   * pricing-settings: anchoring: remove anchor rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/pricing-settings%3A%20anchoring%3A%20remove%20anchor%20rule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  pricingSettingsAnchoringRemoveAnchorRule(
    options?: EventOptions,
  ) {
    return this.track(new PricingSettingsAnchoringRemoveAnchorRule(), options);
  }

  /**
   * products: interpretation
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/products%3A%20interpretation)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Engine)
   * @param options Amplitude event options.
   */
  productsInterpretation(
    properties?: ProductsInterpretationProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProductsInterpretation(properties), options);
  }

  /**
   * promo: Create
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20Create)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoCreate(
    options?: EventOptions,
  ) {
    return this.track(new PromoCreate(), options);
  }

  /**
   * promo: Delete
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20Delete)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoDelete(
    options?: EventOptions,
  ) {
    return this.track(new PromoDelete(), options);
  }

  /**
   * promo: Download errors
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20Download%20errors)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoDownloadErrors(
    options?: EventOptions,
  ) {
    return this.track(new PromoDownloadErrors(), options);
  }

  /**
   * promo: Download template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20Download%20template)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoDownloadTemplate(
    options?: EventOptions,
  ) {
    return this.track(new PromoDownloadTemplate(), options);
  }

  /**
   * promo: filter by status
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20filter%20by%20status)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoFilterByStatus(
    options?: EventOptions,
  ) {
    return this.track(new PromoFilterByStatus(), options);
  }

  /**
   * promo: import File
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20import%20File)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoImportFile(
    options?: EventOptions,
  ) {
    return this.track(new PromoImportFile(), options);
  }

  /**
   * promo: open Promo list Page
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20open%20Promo%20list%20Page)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoOpenPromoListPage(
    options?: EventOptions,
  ) {
    return this.track(new PromoOpenPromoListPage(), options);
  }

  /**
   * promo: search
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20search)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoSearch(
    options?: EventOptions,
  ) {
    return this.track(new PromoSearch(), options);
  }

  /**
   * promo: Update
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/promo%3A%20Update)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  promoUpdate(
    options?: EventOptions,
  ) {
    return this.track(new PromoUpdate(), options);
  }

  /**
   * reports: create report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20create%20report)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Is global)
   * @param options Amplitude event options.
   */
  reportsCreateReport(
    properties?: ReportsCreateReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsCreateReport(properties), options);
  }

  /**
   * reports: delete report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20delete%20report)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  reportsDeleteReport(
    properties?: ReportsDeleteReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsDeleteReport(properties), options);
  }

  /**
   * reports: download report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20download%20report)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  reportsDownloadReport(
    properties?: ReportsDownloadReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsDownloadReport(properties), options);
  }

  /**
   * reports: edit report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20edit%20report)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  reportsEditReport(
    properties?: ReportsEditReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsEditReport(properties), options);
  }

  /**
   * reports: open report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20open%20report)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  reportsOpenReport(
    properties?: ReportsOpenReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsOpenReport(properties), options);
  }

  /**
   * reports: open report new window
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20open%20report%20new%20window)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  reportsOpenReportNewWindow(
    properties?: ReportsOpenReportNewWindowProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsOpenReportNewWindow(properties), options);
  }

  /**
   * reports: update report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/reports%3A%20update%20report)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Is global)
   * @param options Amplitude event options.
   */
  reportsUpdateReport(
    properties?: ReportsUpdateReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportsUpdateReport(properties), options);
  }

  /**
   * repricing: apply prices
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20apply%20prices)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Export final prices file)
   * @param options Amplitude event options.
   */
  repricingApplyPrices(
    properties?: RepricingApplyPricesProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingApplyPrices(properties), options);
  }

  /**
   * repricing: cancel repricing
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20cancel%20repricing)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. OG name)
   * @param options Amplitude event options.
   */
  repricingCancelRepricing(
    properties?: RepricingCancelRepricingProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingCancelRepricing(properties), options);
  }

  /**
   * repricing: commit
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20commit)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. OG name)
   * @param options Amplitude event options.
   */
  repricingCommit(
    properties?: RepricingCommitProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingCommit(properties), options);
  }

  /**
   * repricing: export applied proices
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20export%20applied%20proices)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. OG name)
   * @param options Amplitude event options.
   */
  repricingExportAppliedProices(
    properties?: RepricingExportAppliedProicesProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingExportAppliedProices(properties), options);
  }

  /**
   * repricing: restart
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20restart)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Is scheduled)
   * @param options Amplitude event options.
   */
  repricingRestart(
    properties?: RepricingRestartProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingRestart(properties), options);
  }

  /**
   * repricing: start
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20start)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Is scheduled)
   * @param options Amplitude event options.
   */
  repricingStart(
    properties?: RepricingStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingStart(properties), options);
  }

  /**
   * repricing: stop
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/repricing%3A%20stop)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. OG name)
   * @param options Amplitude event options.
   */
  repricingStop(
    properties?: RepricingStopProperties,
    options?: EventOptions,
  ) {
    return this.track(new RepricingStop(properties), options);
  }

  /**
   * saved-filters: click on filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/saved-filters%3A%20click%20on%20filter)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. from)
   * @param options Amplitude event options.
   */
  savedFiltersClickOnFilter(
    properties?: SavedFiltersClickOnFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new SavedFiltersClickOnFilter(properties), options);
  }

  /**
   * scenario panel: edit: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20edit%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelEditClick(
    properties?: ScenarioPanelEditClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelEditClick(properties), options);
  }

  /**
   * scenario panel: pricing campaign: edit: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20pricing%20campaign%3A%20edit%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelPricingCampaignEditClick(
    properties?: ScenarioPanelPricingCampaignEditClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelPricingCampaignEditClick(properties), options);
  }

  /**
   * scenario panel: pricing campaign: remove: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20pricing%20campaign%3A%20remove%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelPricingCampaignRemoveClick(
    properties?: ScenarioPanelPricingCampaignRemoveClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelPricingCampaignRemoveClick(properties), options);
  }

  /**
   * scenario panel: pricing campaign: select
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20pricing%20campaign%3A%20select)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelPricingCampaignSelect(
    properties?: ScenarioPanelPricingCampaignSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelPricingCampaignSelect(properties), options);
  }

  /**
   * scenario panel: remove: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20remove%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelRemoveClick(
    properties?: ScenarioPanelRemoveClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelRemoveClick(properties), options);
  }

  /**
   * scenario panel: select scenario
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%20panel%3A%20select%20scenario)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioPanelSelectScenario(
    properties?: ScenarioPanelSelectScenarioProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPanelSelectScenario(properties), options);
  }

  /**
   * scenario: changes saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%3A%20changes%20saved)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  scenarioChangesSaved(
    options?: EventOptions,
  ) {
    return this.track(new ScenarioChangesSaved(), options);
  }

  /**
   * scenario: delete
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%3A%20delete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioDelete(
    properties?: ScenarioDeleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioDelete(properties), options);
  }

  /**
   * scenario: duplicate
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%3A%20duplicate)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioDuplicate(
    properties?: ScenarioDuplicateProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioDuplicate(properties), options);
  }

  /**
   * scenario: promote clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%3A%20promote%20clicked)
   *
   * This event is triggered when a user clicks the "Promote" button within a scenario in the Platform PROD application.
   *
   * @param options Amplitude event options.
   */
  scenarioPromoteClicked(
    options?: EventOptions,
  ) {
    return this.track(new ScenarioPromoteClicked(), options);
  }

  /**
   * scenario: tab: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenario%3A%20tab%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenarioTabClick(
    properties?: ScenarioTabClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenarioTabClick(properties), options);
  }

  /**
   * scenarios: add panel
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20add%20panel)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosAddPanel(
    properties?: ScenariosAddPanelProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosAddPanel(properties), options);
  }

  /**
   * scenarios: create scenario
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20create%20scenario)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosCreateScenario(
    properties?: ScenariosCreateScenarioProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosCreateScenario(properties), options);
  }

  /**
   * scenarios: duplicate pricing campaigns
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20duplicate%20pricing%20campaigns)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosDuplicatePricingCampaigns(
    properties?: ScenariosDuplicatePricingCampaignsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosDuplicatePricingCampaigns(properties), options);
  }

  /**
   * scenarios: pricing campaigns: delete
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20pricing%20campaigns%3A%20delete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosPricingCampaignsDelete(
    properties?: ScenariosPricingCampaignsDeleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosPricingCampaignsDelete(properties), options);
  }

  /**
   * scenarios: pricing campaigns: reorder
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20pricing%20campaigns%3A%20reorder)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosPricingCampaignsReorder(
    properties?: ScenariosPricingCampaignsReorderProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosPricingCampaignsReorder(properties), options);
  }

  /**
   * scenarios: run
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20run)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosRun(
    properties?: ScenariosRunProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosRun(properties), options);
  }

  /**
   * scenarios: select tab
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20select%20tab)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosSelectTab(
    properties?: ScenariosSelectTabProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosSelectTab(properties), options);
  }

  /**
   * scenarios: sidebar: select scenario
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/scenarios%3A%20sidebar%3A%20select%20scenario)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  scenariosSidebarSelectScenario(
    properties?: ScenariosSidebarSelectScenarioProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScenariosSidebarSelectScenario(properties), options);
  }

  /**
   * settings: copy settings: confirm
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20copy%20settings%3A%20confirm)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsCopySettingsConfirm(
    options?: EventOptions,
  ) {
    return this.track(new SettingsCopySettingsConfirm(), options);
  }

  /**
   * settings: copy settings: finish
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20copy%20settings%3A%20finish)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsCopySettingsFinish(
    options?: EventOptions,
  ) {
    return this.track(new SettingsCopySettingsFinish(), options);
  }

  /**
   * settings: copy settings: select settings
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20copy%20settings%3A%20select%20settings)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Settings to copy)
   * @param options Amplitude event options.
   */
  settingsCopySettingsSelectSettings(
    properties?: SettingsCopySettingsSelectSettingsProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsCopySettingsSelectSettings(properties), options);
  }

  /**
   * settings: copy settings: start
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20copy%20settings%3A%20start)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsCopySettingsStart(
    options?: EventOptions,
  ) {
    return this.track(new SettingsCopySettingsStart(), options);
  }

  /**
   * settings: dropdown: apply template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20dropdown%3A%20apply%20template)
   *
   * Records the application of a predefined template to the Pricing Campaign from the PC dropdown menu.
   *
   * @param options Amplitude event options.
   */
  settingsDropdownApplyTemplate(
    options?: EventOptions,
  ) {
    return this.track(new SettingsDropdownApplyTemplate(), options);
  }

  /**
   * settings: dropdown: save setting as template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20dropdown%3A%20save%20setting%20as%20template)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsDropdownSaveSettingAsTemplate(
    options?: EventOptions,
  ) {
    return this.track(new SettingsDropdownSaveSettingAsTemplate(), options);
  }

  /**
   * settings: og modal: tab: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20og%20modal%3A%20tab%3A%20click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  settingsOgModalTabClick(
    properties?: SettingsOgModalTabClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsOgModalTabClick(properties), options);
  }

  /**
   * settings: pricing campaigns: add a minimal price change
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20add%20a%20minimal%20price%20change)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsAddAMinimalPriceChange(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsAddAMinimalPriceChange(), options);
  }

  /**
   * settings: pricing campaigns: add rounding rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20add%20rounding%20rule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsAddRoundingRule(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsAddRoundingRule(), options);
  }

  /**
   * settings: pricing campaigns: bulk delete PCs
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20bulk%20delete%20PCs)
   *
   * Records the action of deleting multiple pricing campaigns.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsBulkDeletePCs(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsBulkDeletePCs(), options);
  }

  /**
   * settings: pricing campaigns: create pc: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20create%20pc%3A%20click)
   *
   * Tracks when a user initiates the creation of a new pricing campaign by clicking the corresponding button or link.
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsCreatePcClick(
    properties?: SettingsPricingCampaignsCreatePcClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsCreatePcClick(properties), options);
  }

  /**
   * settings: pricing campaigns: delete a minimal price change
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20delete%20a%20minimal%20price%20change)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDeleteAMinimalPriceChange(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDeleteAMinimalPriceChange(), options);
  }

  /**
   * settings: pricing campaigns: delete PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20delete%20PC)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDeletePc(
    properties: SettingsPricingCampaignsDeletePcProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDeletePc(properties), options);
  }

  /**
   * settings: pricing campaigns: delete rounding rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20delete%20rounding%20rule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDeleteRoundingRule(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDeleteRoundingRule(), options);
  }

  /**
   * settings: pricing campaigns: demand strategy: change click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20demand%20strategy%3A%20change%20click)
   *
   * Tracks when a user clicks on the demand strategy link in the tactics tab.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDemandStrategyChangeClick(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDemandStrategyChangeClick(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: apply template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20apply%20template)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownApplyTemplate(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownApplyTemplate(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: copy PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20copy%20PC)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownCopyPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownCopyPc(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: dublicate PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20dublicate%20PC)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownDublicatePc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownDublicatePc(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: reassign to another OG
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20reassign%20to%20another%20OG)
   *
   * Tracks when a user selects the option to reassign a pricing campaign to a different optimization group from the dropdown menu in the settings.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownReassignToAnotherOg(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownReassignToAnotherOg(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: save ps as template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20save%20ps%20as%20template)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownSavePsAsTemplate(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownSavePsAsTemplate(), options);
  }

  /**
   * settings: pricing campaigns: dropdown: save setting as template
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20dropdown%3A%20save%20setting%20as%20template)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsDropdownSaveSettingAsTemplate(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsDropdownSaveSettingAsTemplate(), options);
  }

  /**
   * settings: pricing campaigns: edit rounding rule
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20edit%20rounding%20rule)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsEditRoundingRule(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsEditRoundingRule(), options);
  }

  /**
   * settings: pricing campaigns: filter apply
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20filter%20apply)
   *
   * Records the application of advanced filters to refine the list of pricing campaigns based on selected criteria.
   *
   * @param properties The event's properties (e.g. rules)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsFilterApply(
    properties?: SettingsPricingCampaignsFilterApplyProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsFilterApply(properties), options);
  }

  /**
   * settings: pricing campaigns: markdown period: add period
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20markdown%20period%3A%20add%20period)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsMarkdownPeriodAddPeriod(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsMarkdownPeriodAddPeriod(), options);
  }

  /**
   * settings: pricing campaigns: markdown period: delete period
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20markdown%20period%3A%20delete%20period)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsMarkdownPeriodDeletePeriod(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsMarkdownPeriodDeletePeriod(), options);
  }

  /**
   * settings: pricing campaigns: markdown: change click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20markdown%3A%20change%20click)
   *
   * Tracks user clicking on  the Markdown settings link in the tactics tab.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsMarkdownChangeClick(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsMarkdownChangeClick(), options);
  }

  /**
   * settings: pricing campaigns: products count click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20products%20count%20click)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsProductsCountClick(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsProductsCountClick(), options);
  }

  /**
   * settings: pricing campaigns: reorder: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20reorder%3A%20click)
   *
   * Tracks when a user clicks to reorder pricing campaigns, indicating intent to change the sequence or priority of campaigns.
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsReorderClick(
    properties?: SettingsPricingCampaignsReorderClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsReorderClick(properties), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: anchoring to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20anchoring%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingAnchoringToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingAnchoringToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: minimal_steps to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20minimal_steps%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingMinimalStepsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingMinimalStepsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: price_limits to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20price_limits%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingPriceLimitsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingPriceLimitsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: pricing_tactics to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20pricing_tactics%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingPricingTacticsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingPricingTacticsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: product_assignments to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20product_assignments%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingProductAssignmentsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingProductAssignmentsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: rounding to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20rounding%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingRoundingToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingRoundingToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.activity to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.activity%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsActivityToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsActivityToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.anchoring to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.anchoring%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsAnchoringToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsAnchoringToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.minimal_steps to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.minimal_steps%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsMinimalStepsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsMinimalStepsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.price_limits to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.price_limits%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPc(
    properties?: SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPcProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPriceLimitsToPc(properties), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.pricing_tactics to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.pricing_tactics%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPricingTacticsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsPricingTacticsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.product_assignments to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.product_assignments%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsProductAssignmentsToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsProductAssignmentsToPc(), options);
  }

  /**
   * settings: pricing campaigns: setting: dropdown: copy PC setting: settings.rounding to PC
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20setting%3A%20dropdown%3A%20copy%20PC%20setting%3A%20settings.rounding%20to%20PC)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsSettingDropdownCopyPcSettingSettingsRoundingToPc(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsSettingDropdownCopyPcSettingSettingsRoundingToPc(), options);
  }

  /**
   * settings: pricing campaigns: strategy: change period
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20strategy%3A%20change%20period)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsStrategyChangePeriod(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsStrategyChangePeriod(), options);
  }

  /**
   * settings: pricing campaigns: table: duplicate PCs
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20table%3A%20duplicate%20PCs)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsTableDuplicatePCs(
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsTableDuplicatePCs(), options);
  }

  /**
   * settings: pricing campaigns: table: select copy option
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20table%3A%20select%20copy%20option)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsTableSelectCopyOption(
    properties?: SettingsPricingCampaignsTableSelectCopyOptionProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsTableSelectCopyOption(properties), options);
  }

  /**
   * settings: pricing campaigns: table: sort by
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20table%3A%20sort%20by)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsTableSortBy(
    properties?: SettingsPricingCampaignsTableSortByProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsTableSortBy(properties), options);
  }

  /**
   * settings: pricing campaigns: view: click
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20pricing%20campaigns%3A%20view%3A%20click)
   *
   * Tracks user interaction when clicking to view details of pricing campaigns. Opens PC modal.
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  settingsPricingCampaignsViewClick(
    properties?: SettingsPricingCampaignsViewClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPricingCampaignsViewClick(properties), options);
  }

  /**
   * settings: promo campaigns: table: sort by
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/settings%3A%20promo%20campaigns%3A%20table%3A%20sort%20by)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. value)
   * @param options Amplitude event options.
   */
  settingsPromoCampaignsTableSortBy(
    properties: SettingsPromoCampaignsTableSortByProperties,
    options?: EventOptions,
  ) {
    return this.track(new SettingsPromoCampaignsTableSortBy(properties), options);
  }

  /**
   * sku sidebar: opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/sku%20sidebar%3A%20opened)
   *
   * This event is triggered when a user opens the SKU sidebar.
   *
   * @param options Amplitude event options.
   */
  skuSidebarOpened(
    options?: EventOptions,
  ) {
    return this.track(new SkuSidebarOpened(), options);
  }

  /**
   * sku sidebar: tab clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/sku%20sidebar%3A%20tab%20clicked)
   *
   * This event is triggered when a user clicks on a tab within the SKU sidebar.
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  skuSidebarTabClicked(
    properties?: SkuSidebarTabClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SkuSidebarTabClicked(properties), options);
  }

  /**
   * table: add quick filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20add%20quick%20filter)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. preferenceKey)
   * @param options Amplitude event options.
   */
  tableAddQuickFilter(
    properties?: TableAddQuickFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableAddQuickFilter(properties), options);
  }

  /**
   * table: anchor approval: apply filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20anchor%20approval%3A%20apply%20filter)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tableAnchorApprovalApplyFilter(
    options?: EventOptions,
  ) {
    return this.track(new TableAnchorApprovalApplyFilter(), options);
  }

  /**
   * table: anchor strategy: apply filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20anchor%20strategy%3A%20apply%20filter)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tableAnchorStrategyApplyFilter(
    options?: EventOptions,
  ) {
    return this.track(new TableAnchorStrategyApplyFilter(), options);
  }

  /**
   * table: apply latest filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20apply%20latest%20filter)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableApplyLatestFilter(
    options?: EventOptions,
  ) {
    return this.track(new TableApplyLatestFilter(), options);
  }

  /**
   * table: assign to anchors
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20assign%20to%20anchors)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tableAssignToAnchors(
    options?: EventOptions,
  ) {
    return this.track(new TableAssignToAnchors(), options);
  }

  /**
   * table: assign to anchors: save
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20assign%20to%20anchors%3A%20save)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tableAssignToAnchorsSave(
    options?: EventOptions,
  ) {
    return this.track(new TableAssignToAnchorsSave(), options);
  }

  /**
   * table: assign to pricing campaign
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20assign%20to%20pricing%20campaign)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Assign to)
   * @param options Amplitude event options.
   */
  tableAssignToPricingCampaign(
    properties?: TableAssignToPricingCampaignProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableAssignToPricingCampaign(properties), options);
  }

  /**
   * table: clear quick filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20clear%20quick%20filter)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. preferenceKey)
   * @param options Amplitude event options.
   */
  tableClearQuickFilter(
    properties?: TableClearQuickFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableClearQuickFilter(properties), options);
  }

  /**
   * table: clear selection
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20clear%20selection)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tableClearSelection(
    options?: EventOptions,
  ) {
    return this.track(new TableClearSelection(), options);
  }

  /**
   * table: import from file
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20import%20from%20file)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Ignore empty fields)
   * @param options Amplitude event options.
   */
  tableImportFromFile(
    properties?: TableImportFromFileProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableImportFromFile(properties), options);
  }

  /**
   * table: lock price
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20lock%20price)
   *
   * Records instances when a user locks product price to exlude it from repricing flow.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableLockPrice(
    options?: EventOptions,
  ) {
    return this.track(new TableLockPrice(), options);
  }

  /**
   * table: manual update
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20manual%20update)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Amount of fields for updating)
   * @param options Amplitude event options.
   */
  tableManualUpdate(
    properties?: TableManualUpdateProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableManualUpdate(properties), options);
  }

  /**
   * table: new price editing
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20new%20price%20editing)
   *
   * Captures each instance of initiating or modifying a "new price"  cell of a product in the "products table".
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. Set new price)
   * @param options Amplitude event options.
   */
  tableNewPriceEditing(
    properties?: TableNewPriceEditingProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableNewPriceEditing(properties), options);
  }

  /**
   * table: open SKU panel: Market
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20open%20SKU%20panel%3A%20Market)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableOpenSkuPanelMarket(
    options?: EventOptions,
  ) {
    return this.track(new TableOpenSkuPanelMarket(), options);
  }

  /**
   * table: open SKU panel: Performance
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20open%20SKU%20panel%3A%20Performance)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableOpenSkuPanelPerformance(
    options?: EventOptions,
  ) {
    return this.track(new TableOpenSkuPanelPerformance(), options);
  }

  /**
   * table: remove quick filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20remove%20quick%20filter)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. preferenceKey)
   * @param options Amplitude event options.
   */
  tableRemoveQuickFilter(
    properties?: TableRemoveQuickFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableRemoveQuickFilter(properties), options);
  }

  /**
   * table: save changes
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20save%20changes)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableSaveChanges(
    options?: EventOptions,
  ) {
    return this.track(new TableSaveChanges(), options);
  }

  /**
   * table: select all items on all pages
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20select%20all%20items%20on%20all%20pages)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableSelectAllItemsOnAllPages(
    options?: EventOptions,
  ) {
    return this.track(new TableSelectAllItemsOnAllPages(), options);
  }

  /**
   * table: unassign from pricing campaigns
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20unassign%20from%20pricing%20campaigns)
   *
   * Records the removal of one or more products from specified pricing campaigns, reflecting updates to campaign participation.
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  tableUnassignFromPricingCampaigns(
    options?: EventOptions,
  ) {
    return this.track(new TableUnassignFromPricingCampaigns(), options);
  }

  /**
   * table: update quick filter
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/table%3A%20update%20quick%20filter)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. preferenceKey)
   * @param options Amplitude event options.
   */
  tableUpdateQuickFilter(
    properties?: TableUpdateQuickFilterProperties,
    options?: EventOptions,
  ) {
    return this.track(new TableUpdateQuickFilter(properties), options);
  }

  /**
   * theme: switch to dark mode
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/theme%3A%20switch%20to%20dark%20mode)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  themeSwitchToDarkMode(
    options?: EventOptions,
  ) {
    return this.track(new ThemeSwitchToDarkMode(), options);
  }

  /**
   * theme: switch to light mode
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/theme%3A%20switch%20to%20light%20mode)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  themeSwitchToLightMode(
    options?: EventOptions,
  ) {
    return this.track(new ThemeSwitchToLightMode(), options);
  }

  /**
   * theme: switch to system mode
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/theme%3A%20switch%20to%20system%20mode)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  themeSwitchToSystemMode(
    options?: EventOptions,
  ) {
    return this.track(new ThemeSwitchToSystemMode(), options);
  }

  /**
   * video tutorials: close
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/video%20tutorials%3A%20close)
   *
   * Tracks when a user closes the video tutorial panel.
   *
   * @param properties The event's properties (e.g. tags)
   * @param options Amplitude event options.
   */
  videoTutorialsClose(
    properties?: VideoTutorialsCloseProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoTutorialsClose(properties), options);
  }

  /**
   * video tutorials: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/video%20tutorials%3A%20open)
   *
   * Tracks when a user accesses the video tutorials panel, indicating engagement with educational content.
   *
   * @param properties The event's properties (e.g. tags)
   * @param options Amplitude event options.
   */
  videoTutorialsOpen(
    properties?: VideoTutorialsOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoTutorialsOpen(properties), options);
  }

  /**
   * video tutorials: watch
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/video%20tutorials%3A%20watch)
   *
   * Tracks when a user starts viewing a video tutorial, indicating engagement with educational content.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  videoTutorialsWatch(
    properties?: VideoTutorialsWatchProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoTutorialsWatch(properties), options);
  }

  /**
   * what-if: compare: clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20compare%3A%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. whatif_compare_type)
   * @param options Amplitude event options.
   */
  whatIfCompareClicked(
    properties: WhatIfCompareClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfCompareClicked(properties), options);
  }

  /**
   * what-if: create scenario: modal: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20create%20scenario%3A%20modal%3A%20open)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  whatIfCreateScenarioModalOpen(
    properties?: WhatIfCreateScenarioModalOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfCreateScenarioModalOpen(properties), options);
  }

  /**
   * what-if: create scenario: modal: submit
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20create%20scenario%3A%20modal%3A%20submit)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  whatIfCreateScenarioModalSubmit(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfCreateScenarioModalSubmit(), options);
  }

  /**
   * what-if: duplicate pcs to scenario: modal: open
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20duplicate%20pcs%20to%20scenario%3A%20modal%3A%20open)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. location)
   * @param options Amplitude event options.
   */
  whatIfDuplicatePcsToScenarioModalOpen(
    properties?: WhatIfDuplicatePcsToScenarioModalOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfDuplicatePcsToScenarioModalOpen(properties), options);
  }

  /**
   * what-if: duplicate pcs to scenario: modal: submit
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20duplicate%20pcs%20to%20scenario%3A%20modal%3A%20submit)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param properties The event's properties (e.g. pcs)
   * @param options Amplitude event options.
   */
  whatIfDuplicatePcsToScenarioModalSubmit(
    properties?: WhatIfDuplicatePcsToScenarioModalSubmitProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfDuplicatePcsToScenarioModalSubmit(properties), options);
  }

  /**
   * what-if: restarted
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20restarted)
   *
   * This event is triggered when a user restarts a what-if analysis within the Platform PROD application.
   *
   * @param options Amplitude event options.
   */
  whatIfRestarted(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfRestarted(), options);
  }

  /**
   * what-if: runs set: action clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20runs%20set%3A%20action%20clicked)
   *
   * This event is triggered when a user clicks on an action within the "Runs Set" section of the What-if feature. It captures the specific user interaction with available options or commands related to scenario runs.
   *
   * @param properties The event's properties (e.g. runs_set_action)
   * @param options Amplitude event options.
   */
  whatIfRunsSetActionClicked(
    properties: WhatIfRunsSetActionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfRunsSetActionClicked(properties), options);
  }

  /**
   * what-if: scenario: edit clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20scenario%3A%20edit%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  whatIfScenarioEditClicked(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfScenarioEditClicked(), options);
  }

  /**
   * what-if: scenario: rename clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20scenario%3A%20rename%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  whatIfScenarioRenameClicked(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfScenarioRenameClicked(), options);
  }

  /**
   * what-if: summary: chart tab clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20chart%20tab%20clicked)
   *
   * This event is triggered when a user clicks on the Chart tab within the What-if summary section.
   *
   * @param properties The event's properties (e.g. tab)
   * @param options Amplitude event options.
   */
  whatIfSummaryChartTabClicked(
    properties?: WhatIfSummaryChartTabClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryChartTabClicked(properties), options);
  }

  /**
   * what-if: summary: delete row
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20delete%20row)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  whatIfSummaryDeleteRow(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryDeleteRow(), options);
  }

  /**
   * what-if: summary: download report
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20download%20report)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  whatIfSummaryDownloadReport(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryDownloadReport(), options);
  }

  /**
   * what-if: summary: duplicate clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20duplicate%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  whatIfSummaryDuplicateClicked(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryDuplicateClicked(), options);
  }

  /**
   * what-if: summary: promote clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20promote%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  whatIfSummaryPromoteClicked(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryPromoteClicked(), options);
  }

  /**
   * what-if: summary: re-run
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20re-run)
   *
   * Owner: Dmitriy Chernyak
   *
   * @param options Amplitude event options.
   */
  whatIfSummaryReRun(
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryReRun(), options);
  }

  /**
   * what-if: summary: run
   *
   * [View in Tracking Plan](https://data.amplitude.com/competera/Platform%20PROD/events/main/latest/what-if%3A%20summary%3A%20run)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Page Domain)
   * @param options Amplitude event options.
   */
  whatIfSummaryRun(
    properties?: WhatIfSummaryRunProperties,
    options?: EventOptions,
  ) {
    return this.track(new WhatIfSummaryRun(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
